// 10-26 rep-for pricing helpers (Jeff: "rep mode should honor the retailer's prices"). A rep's order is a draft
// priced by tt-b2b-relay from the same rules.json as the theme's tta-sale-rules: wholesale less the retailer's
// best promo per line. main-cart.liquid renders {product_id: pct} into #td-rep-pcts in rep-for mode; these
// reproduce the Liquid's integer-cent math (discount truncated per unit) so a stepper edit can't drift from it.
window.tdRepPcts = function () {
  try { return JSON.parse((document.getElementById('td-rep-pcts') || {}).textContent || '{}'); } catch (e) { return {}; }
};
window.tdRepLine = function (it, pcts) {
  var p = Number((pcts || {})[String(it.product_id)] || 0);
  return (it.original_price - Math.floor(it.original_price * p / 100)) * it.quantity;
};
$(document).ready(function(){
  // Post-login redirect: send the customer back to where they were.
  // Domain-relative so the same code works on ca. and us.throatthreads.com.
  var checkout_url = function(){
      var location_href = location.href;
      if(window.location.pathname == "/account/login"){
        var urlParams = new URLSearchParams(window.location.search);
        location_href = urlParams.get('checkout_url') || '/';
      }
      $('.login-screen').find('#customer form').find('[name="checkout_url"]').val(location_href);
  }

  if($('.login-screen').is(':visible')){
    checkout_url();
  }

  // Re-apply briefly in case the login form re-renders, then stop (was: ran forever).
  var checkoutUrlTries = 0;
  var checkoutUrlInterval = setInterval(function(){
    checkout_url();
    checkoutUrlTries++;
    if(checkoutUrlTries >= 100){ clearInterval(checkoutUrlInterval); }
  }, 100);


  // ATC
$('#atc-btn').on('click', function(e){
  e.preventDefault();

  var $btn = $(this);
  // NB: no early return on td-atc-idle any more. Idle is a visual cue that there is nothing
  // to submit; a buyer who clicks anyway now gets an explanation ("Already in your cart at
  // these quantities" / "No quantities selected") instead of a dead button. Silence on a
  // no-op was the original defect — reinstating it here would just move it.
  // Guard against double-clicks: one submission at a time.
  if ($btn.hasClass('atc-busy')) { return; }
  $btn.addClass('atc-busy disabled').css({'pointer-events':'none','opacity':'0.6'});
  var atcDone = function(){
    $btn.removeClass('atc-busy disabled').css({'pointer-events':'auto','opacity':'1'});
  };

  var form = $(this).closest('form');
  var data = []; // fresh per click — never accumulate across clicks
  var seen = {};

  // Read EVERY cell that maps to a variant — not just the ones the buyer happened to
  // touch this visit. Quantity inputs are pre-filled from the cart on page load
  // (variant-table.liquid: value="{{ quantity_in_cart }}") and every cell is
  // de-selected again after a successful add, so gating submission on .selected made
  // this button a SILENT no-op for any buyer whose sizes were already in their cart:
  // zero requests, no toast, no error. Untouched cells are harmless here — they match
  // the cart and diff to nothing below, so nothing is sent for them, and variants not
  // rendered on this page are never iterated, so other cart lines cannot be clobbered.
  // NB selector kept as CA's own (.data-wrap.inseam) — CA markup never emits
  // .data-wrap.in-seam, so the US copy's wider selector would change nothing but risk.
  // EVERY data-wrap that maps to a variant — across ALL inseams, not just the selected one.
  // Reading only `.data-wrap.inseam` meant a buyer who sized L30 and then switched to L32
  // submitted nothing for L30: theme.js strips the .inseam class from every wrap and re-adds
  // it only to the current selection. Quantities come from ttaQty, which survives the
  // re-render the inseam switch triggers; the DOM is the fallback, not the source of truth.
  var keyed = (window.ttaQty && window.ttaQty.all()) || {};
  $('.v-table-col-main .data-wrap[data-variant]').each(function(){
    var id = $(this).attr('data-variant');
    if (!id || seen[id]) { return; }
    seen[id] = true;
    var domQty = Number($('#quantity-' + id).val());
    var q = (id in keyed) ? keyed[id] : (isNaN(domQty) ? 0 : domQty);
    data.push({ id: id, quantity: q || 0 });
  });

  if (!data.length) { atcDone(); return; }

  $.getJSON('/cart.js', function(cart) {
    const cartItems = cart.items;
    const updateData = [];
    const addData = [];



    data.forEach(item => {
      const cartItem = cartItems.find(ci => ci.variant_id === Number(item.id));
      if (cartItem) {
        // Only send a REAL change. An untouched cell already matches the cart,
        // so it diffs to nothing and is never transmitted.
        if (cartItem.quantity !== item.quantity) {
          updateData.push({
            id: cartItem.key, // full line item key (variant_id:hash)
            quantity: item.quantity // 0 is intentional: removes the line
          });
        }
      } else if (item.quantity > 0) {
        addData.push(item); // new item to add — never send qty 0 to /cart/add.js
      }
    });

    const updatesObj = Object.fromEntries(updateData.map(u => [u.id, u.quantity]));

    // Nothing to change (e.g. only zero-qty cells that were never in the cart):
    // don't show a false success message.
    if (!Object.keys(updatesObj).length && !addData.length) {
      // Tell the truth about WHY nothing moved: "already in your cart" and
      // "you picked nothing" are very different messages to a buyer.
      var wantedUnits = data.reduce(function(n, it){ return n + it.quantity; }, 0);
      $('.cart-message').html(wantedUnits > 0
        ? '<span class="cart-message__check">\u2713</span> Already in your cart at these quantities <a href="/cart">View cart</a>'
        : 'No quantities selected — nothing was added.');
      $('.cart-message').stop(true, true).fadeIn(150).delay(4500).fadeOut(300);
      atcDone();
      return;
    }

    let promise = Promise.resolve();

    // dataType:'json' is REQUIRED. Shopify returns cart JSON with
    // Content-Type: text/javascript, so a bare $.post lets jQuery "intelligently
    // guess" script and globalEval the JSON body — throwing a SyntaxError that
    // rejects the chain and skips the buyer's confirmation.
    if (Object.keys(updatesObj).length) {
      promise = promise.then(() => {
        return $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json',
                        data: { updates: updatesObj } });
      });
    }

    if (addData.length) {
      promise = promise.then(() => {
        return $.ajax({ url: '/cart/add.js', type: 'POST', dataType: 'json',
                        data: { items: addData } });
      });
    }

    promise.then(() => {
      // Feedback where the eyes are: the button itself confirms, then reverts.
      var originalLabel = $btn.attr('data-add-to-cart-text') || 'Add to cart';
      $btn.addClass('atc-added').text('✓ Added to cart');
      setTimeout(function(){ $btn.removeClass('atc-added').text(originalLabel); }, 3200);

      // Booking lane: adding a booking item stamps the ERP-bound identifier
      // onto the cart (Order Type + season) — the relay + checkout both carry it.
      var bkEl = document.querySelector('[data-td-booking-item]');
      if (bkEl) {
        $.ajax({ url: '/cart/update.js', type: 'POST', contentType: 'application/json',
          data: JSON.stringify({ attributes: { 'Order Type': 'BOOKING ' + (bkEl.getAttribute('data-season') || ''), 'Booking Season': bkEl.getAttribute('data-season') || '' } }) });
      }

      // Toast is immediate (not gated on another request) — bottom-right, clear of the header.
      $('.cart-message').html('<span class="cart-message__check">✓</span> Cart updated <a href="/cart">View cart</a>');
      $('.cart-message').stop(true, true).fadeIn(150).delay(4500).fadeOut(300);

      // badge refresh in the background
      $.getJSON('/cart.js', function(cart) {
        if ($('.cart-link__count').length) {
          $('.cart-link__count').html(cart.item_count);
        } else {
          $('.cart-link__icon').append('<span class="cart-link__count">' + cart.item_count + '</span>');
        }
      });

      // ✅ Do NOT reset quantities — but re-baseline so cell states reflect the new cart
      if (window.ttaQty) { window.ttaQty.clear(); window.ttaQty.readDom(); }
      $('.v-table-col-main.selected').removeClass('selected');
      $('.product-detail .data-wrap .quantity-input').each(function(){
        $(this).attr('data-initial', parseInt($(this).val()) || 0);
        syncCellState($(this).closest('.data-wrap'));
      });

      atcDone();
    }).catch(xhr => {
      let errorMessage = 'Something went wrong. Please try again.';
      try {
        const errorData = JSON.parse(xhr.responseText);
        if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        console.warn('Failed to parse error response:', e);
      }

      $('.cart-message').html('<span class="error">' + errorMessage + '</span>');
      $('.cart-message').fadeIn().delay(5000).fadeOut();

      atcDone();
    });
  }).fail(function(){
    atcDone();
  });
});
  // ---- shared cell-state helpers (PDP + cart) ----
  // State classes live on .v-table-data (the element that owns the visible
  // border) so we restyle ONE ring — layering a second inner ring on
  // .data-wrap read as a rendering glitch.
  function cellBox($wrap){
    var $box = $wrap.closest('.v-table-data');
    return $box.length ? $box : $wrap;
  }
  function flashMax($wrap){
    var $box = cellBox($wrap);
    $box.addClass('cell-max');
    setTimeout(function(){ $box.removeClass('cell-max'); }, 1200);
  }
  function syncCellState($wrap){
    var $input = $wrap.find('.quantity-input');
    var qty = parseInt($input.val()) || 0;
    var initial = parseInt($input.attr('data-initial')) || 0;
    $wrap.toggleClass('has-qty', qty > 0); // kept for any legacy selectors
    cellBox($wrap).toggleClass('cell-filled', qty > 0)
                  .toggleClass('cell-remove', qty === 0 && initial > 0);
  }
  // remember starting quantities (cells pre-filled from the cart) + initial visual state
  $('.data-wrap').each(function(){
    var $input = $(this).find('.quantity-input');
    if ($input.length) {
      $input.attr('data-initial', parseInt($input.val()) || 0);
      syncCellState($(this));
    }
  });

  // ---- PDP running order summary ("7 units · $834.40") ----
  function recalcOrderSummary(){
    var $s = $('[data-order-summary]');
    if (!$s.length) return;
    // count across ALL inseams from the state map. Reading only the visible wraps let the
    // summary announce units that had already been reset out of the DOM by a re-render —
    // the buyer saw "4 units selected · $444.80" and added an EMPTY cart.
    var units = 0, cents = 0;
    var keyedNow = (window.ttaQty && window.ttaQty.all()) || null;
    // ⚠️ Sep 9 (Jeff: "the bottom bar doesn't show my price, it shows the wholesale"). This used to
    // total data-price, which is raw variant.price, so the sticky buy bar contradicted the discounted
    // figure the page was displaying two inches above it. Each cell now also carries
    // data-price-eff (what THIS viewer pays) and data-price-promo (what the retailer pays).
    // In rep mode the rep must be quoted the RETAILER's price, never their own staff rate — same
    // policy as the cart (see applyCartTotals) and the card/PDP display. Falls back to data-price so
    // a cached page rendered before this change still totals something sane.
    function unitCents($w){
      var rep = document.documentElement.classList.contains('td-rep-on') ||
                document.body.classList.contains('td-rep-on');
      // ⚠️ rep mode totals the RETAILER'S PROMO, not the rep's staff price and not wholesale. The relay
      // resolves that promo server-side and applies it to the draft, so this is what the order carries.
      var v = parseInt($w.attr(rep ? 'data-price-promo' : 'data-price-eff'));
      if (isNaN(v)) { v = parseInt($w.attr('data-price')); }
      return isNaN(v) ? 0 : v;
    }
    if (keyedNow) {
      $('.product-detail .v-table-main .data-wrap[data-variant]').each(function(){
        var id = $(this).attr('data-variant');
        var q = keyedNow[id] || 0;
        if (q > 0) { units += q; cents += q * unitCents($(this)); }
      });
    } else {
      $('.product-detail .v-table-main .data-wrap').each(function(){
        var q = parseInt($(this).find('.quantity-input').val()) || 0;
        if (q > 0) { units += q; cents += q * unitCents($(this)); }
      });
    }
    $s.find('.order-summary__units').text(units + (units === 1 ? ' unit' : ' units') + ' selected');
    // Aug 25: idle used to mean "0 units", which made the button refuse to submit a REMOVAL —
    // zeroing the only line in your cart set idle and the click handler returned, so a buyer
    // could never empty a line from a PDP. Since the add-to-cart diff now treats qty 0 as a
    // real removal instruction, idle must mean "nothing to submit", not "nothing selected".
    // data-initial is the cart snapshot: set on load from the pre-filled value and
    // re-baselined after every successful add.
    var dirty = 0;
    $('.product-detail .v-table-main .data-wrap').each(function(){
      var $i = $(this).find('.quantity-input');
      if (!$i.length) return;
      if ((parseInt($i.val()) || 0) !== (parseInt($i.attr('data-initial')) || 0)) dirty++;
    });
    var $atc = $('#atc-btn');
    if ($atc.length && !$atc.hasClass('atc-busy') && !$atc.prop('disabled')) {
      $atc.toggleClass('td-atc-idle', dirty === 0).attr('aria-disabled', dirty === 0 ? 'true' : null);
    }
    var money = '';
    if (units > 0 && window.Shopify && Shopify.formatMoney) {
      money = Shopify.formatMoney(cents, $('body').attr('data-mf'));
    }
    $s.find('.order-summary__total').text(money);
  }
  window.ttaRecalcSummary = recalcOrderSummary;
  recalcOrderSummary();

  // qty adjustments — PDP grid only (the cart grid has its own AJAX handler below)
  $('.product-detail .qtybox .btnqty').on('click', function () {
  var $qtyBox = $(this).parent('.qtybox');
  var $input = $qtyBox.find('.quantity-input');
  var $dataWrap = $(this).closest('.data-wrap');
  var $invNum = $dataWrap.find('.inv-num');
  if (!$invNum.length) { $invNum = $dataWrap.find('.inv-qty'); }
  var $plusBtn = $qtyBox.find('.qtyplus');

  var qty = parseInt($input.val()) || 0;
  var inventory = parseInt($invNum.text()) || 0;
  var max = parseInt($input.attr('max')) || inventory;

  // booking items sell at zero inventory — no stock ceiling applies
  var isBooking = $dataWrap.closest('.td-booking-matrix').length > 0;

  if ($(this).hasClass('qtyplus')) {
    if (isBooking) {
      qty++;
    } else if (inventory > 0 && qty < max) {
      qty++;
      inventory--;
    } else {
      flashMax($dataWrap); // let the buyer know they hit available stock
    }
  } else {
    if (qty > 0) {
      qty--;
      if (!isBooking) inventory++;
    }
  }

  $input.val(qty);
  $invNum.text(inventory);

  // Keep the cell submittable once touched (qty 0 on an in-cart size = removal)
  $(this).closest('.v-table-col-main').addClass('selected');
  syncCellState($dataWrap);
  recalcOrderSummary();

  // Disable plus button if inventory is 0
  if (inventory <= 0) {
    $plusBtn.addClass('disabled').css('pointer-events', 'none').css('opacity', '0.5');
  } else {
    $plusBtn.removeClass('disabled').css('pointer-events', 'auto').css('opacity', '1');
  }
});

  $('.product-detail .v-table-main .quantity-selector').on('input', function(e){
    e.preventDefault();
    var q = $(this).val();
    if(q != 0){
      $(this).closest('.v-table-col-main').addClass('selected');
    }
    else{
      $(this).closest('.v-table-col-main').removeClass('selected');
    }
    syncCellState($(this).closest('.data-wrap'));
    recalcOrderSummary();
  });


  if(localStorage.getItem('hidePrice') == '1'){
    $('body').addClass('no-price');	
    if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
    }
    else{
      $('.price-cont').show();
    }
    $('.toggle-price i').attr('class','bi bi-eye-slash');
  }
  else{
    $('body').removeClass('no-price');
       if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
      }
      else{
          $('.price-cont').show();
      }
    $('.toggle-price i').attr('class','bi bi-eye');
  }
  
  // Measure the chrome that is actually pinned to the top of the viewport, so the sticky
  // sizing strip parks directly under it instead of behind it. Measured because the header
  // height is not a constant: --theme-sticky-header-height is 174px in one place and 60px
  // in another, and the utility strip only exists for a logged-in customer.
  function ttaSyncCtxTop() {
    // Measure the element that is ACTUALLY sticky. The first version summed .td-utility and
    // #pageheader, but neither is positioned — the sticky element is their common ancestor
    // .shopify-section.section-header. Both children reported position:static, the sum came
    // out 0, and the context bar parked at viewport top BEHIND the header, invisible.
    // Use the outermost pinned ancestor's BOTTOM edge so a partially-scrolled header works.
    var best = null;
    var cands = document.querySelectorAll(
      '#shopify-section-header, .shopify-section.section-header, .pageheader, #pageheader, .td-utility');
    Array.prototype.forEach.call(cands, function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height <= 0 || r.top > window.innerHeight / 2) return;
      if (!best || el.contains(best)) best = el;          // prefer the outermost
    });
    var h = best ? Math.round(best.getBoundingClientRect().bottom) : 0;
    if (h < 0) h = 0;
    document.documentElement.style.setProperty('--td-ctx-top', h + 'px');
  }
  ttaSyncCtxTop();
  window.addEventListener('resize', ttaSyncCtxTop);
  window.addEventListener('load', ttaSyncCtxTop);
  window.addEventListener('scroll', ttaSyncCtxTop, { passive: true });

  // price button in header
  // REWRITTEN 08-26. This used to set document.location to append/strip a "?NoPrice" flag —
  // a FULL PAGE RELOAD to toggle a CSS class. NoPrice is read by nothing in this theme
  // (grepped: zero hits outside this handler); the real state is localStorage.hidePrice +
  // body.no-price. On a phone the reload was actively destructive: it threw away scroll
  // position halfway down a size grid AND wiped every keyed quantity the buyer had not yet
  // added, because the inputs re-render from quantity_in_cart. Now it is a class flip, and
  // the URL is kept in sync with replaceState so nothing navigates.
  function ttaApplyPriceMode(hidden) {
    $('body').toggleClass('no-price', hidden);
    hidden ? $('.price-cont').hide() : $('.price-cont').show();
    $('.toggle-price i').attr('class', hidden ? 'bi bi-eye-slash' : 'bi bi-eye');
    $('.toggle-price').attr('aria-pressed', hidden ? 'true' : 'false')
      .attr('title', hidden ? 'Show prices' : 'Hide prices (floor mode)');
    try {
      var u = new URL(window.location.href);
      hidden ? u.searchParams.set('NoPrice', '1') : u.searchParams.delete('NoPrice');
      history.replaceState(null, '', u.pathname + (u.search || '') + (u.hash || ''));
    } catch (err) { /* replaceState is a nicety, never worth breaking the toggle over */ }
  }
  $('.toggle-price').on('click', function (e) {
    e.preventDefault();
    var hidden = localStorage.getItem('hidePrice') !== '1';
    localStorage.setItem('hidePrice', hidden ? '1' : '0');
    ttaApplyPriceMode(hidden);
  });
  // stacked images
  if($('body').hasClass('template-suffix-marketing')){
    $(".gallery a.open-gallery").fancybox({
      arrows: "true",
      infobar: "true",
      smallBtn: "auto",
      buttons: [
        "zoom",
        //"share",
        "slideShow",
        //"fullScreen",
        //"download",
        "thumbs",
        "close"
      ],
    });
  }
  // mobile footer — only intercept links that actually have a sub-menu to
  // toggle; plain links must navigate (footer menus are flat lists now)
  // 08-26: extended 767 -> 1024. A tablet was getting the fully expanded footer — an
  // audit counted 34 sub-44px links there — and the page carried its full ~2,300px.
  var media = window.matchMedia("(max-width: 1024px)");
  if (media.matches) {
    $('#shopify-section-footer ul.section-footer__menu-block__menu > li > a').on('click', function(e){
      var $child = $(this).next('ul.child');
      if (!$child.length) { return; } // no accordion here: normal navigation
      e.preventDefault();
      $(this).toggleClass('open');
      $child.toggleClass('open');
    });

    // 08-26. The footer is ~2,337px of fully-expanded links at the end of EVERY page on a
    // phone. The original link-level handler went dead when the menus were flattened, and my
    // first replacement assumed a block-per-column structure — the DOM actually has ONE menu
    // block with no title and a single flat <ul>, so it bound to nothing. (Probed, not
    // guessed: blockCount 1, titleIsDirectChild false.)
    // Real structure: <li class="footer-group-label">HEADING</li> followed by sibling <li>
    // items until the next label. So group by label and collapse the run that follows it.
    $('#shopify-section-footer .section-footer__menu-block__menu').each(function () {
      var $ul = $(this);
      $ul.children('li.footer-group-label').each(function (gi) {
        var $label = $(this);
        var $items = $label.nextUntil('li.footer-group-label');
        if (!$items.length) { return; }
        var id = 'td-fgrp-' + gi;
        $items.addClass('td-facc-item').attr('data-facc-group', id);
        $label
          .removeAttr('aria-hidden')          // it was decorative; it is a control now
          .attr({ role: 'button', tabindex: '0', 'aria-expanded': 'false', 'aria-controls': id })
          .addClass('td-facc');
        function toggle() {
          var open = $label.attr('aria-expanded') !== 'true';
          $label.attr('aria-expanded', open ? 'true' : 'false').toggleClass('is-open', open);
          $items.toggleClass('is-open', open);
        }
        $label.on('click', function (e) { e.preventDefault(); toggle(); });
        $label.on('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); toggle(); }
        });
      });
    });
  }
  
  var parent = $('.navigation__link.active').attr('data-parent');
  $('.navigation__tier-1 .navigation__link[data-main="'+parent+'"]').addClass('active');
  $('.v-table-main .quantity-selector').on('input', function(){
    var max = Number($(this).attr('max'));
    var v = Number($(this).val());
    console.log(v,max)
    if(v > max){
      $(this).val(max);
    }
  });
  // cart page variant table — one visible row per style; blanks default to 0
  $('.cart-item').each(function(){
    var handle = $(this).attr('data-handle');
    if($('.cart-item[data-handle="'+handle+'"]').length >= 1){
      $('.cart-item[data-handle="'+handle+'"]:not(:first)').hide();
      $('.cart-item[data-handle="'+handle+'"]').find('#cart-variant-table input').each(function(){
        if($(this).val() == ''){
        	$(this).val(0);
        }
      })
      return;
    }

  });

  // ---- AJAX cart editing: no page reload per click. Rapid clicks are batched
  // (700ms debounce) into one /cart/update.js call; totals update in place. ----
  var pendingUpdates = {};
  var cartUpdateTimer = null;

  function applyCartTotals(cart){
    var mf = $('body').attr('data-mf');
    paintedFrom(cart);
    // 10-26: rep-for mode = what the relay's draft will charge: wholesale less the RETAILER's promo
    // (never the rep's own staff rate). The % per product comes from #td-rep-pcts, which main-cart.liquid
    // renders from the same rules (td-rep-line); same integer-cent truncation as the Liquid.
    var repOn = !!(cart.attributes && cart.attributes['Ordering For Id']) && document.body.classList.contains('td-rep-on');
    var repPcts = window.tdRepPcts();
    var repTotal = 0;
    cart.items.forEach(function(it){ repTotal += window.tdRepLine(it, repPcts); });
    $('.cart-item:visible').each(function(){
      var $row = $(this);
      var pid = String($row.attr('data-product'));
      var units = 0, totalCents = 0, origCents = 0;
      cart.items.forEach(function(it){
        // rep-for mode shows the retailer's price (the rep's own staff pricing must not bleed into it)
        var repFor = repOn;
        if (String(it.product_id) === pid) { units += it.quantity; totalCents += (repFor ? window.tdRepLine(it, repPcts) : it.final_line_price); origCents += it.original_line_price; }
      });
      $row.find('.cart-item__quantity p').html('<span class="mobile-only">Units:</span>' + units);
      $row.find('.cart-item__total .theme-money').last().text(Shopify.formatMoney(totalCents, mf));
      // keep the consolidated discount row honest after stepper edits (AAA/codex Jul 27)
      var discCents = origCents - totalCents;
      var $disc = $row.find('.cart-discount__amount');
      if ($disc.length) {
        $disc.text('-' + Shopify.formatMoney(discCents, mf));
        // title mirrors the Liquid: one distinct title → it; several → "Discounts"
        var titles = [];
        cart.items.forEach(function(it){
          if (String(it.product_id) !== pid) return;
          (it.line_level_discount_allocations || []).forEach(function(d){
            var t = d.discount_application && d.discount_application.title;
            if (t && titles.indexOf(t) < 0) titles.push(t);
          });
        });
        $row.find('.cart-discount__title').text(repOn ? 'Retailer promotion' : (titles.length > 1 ? 'Discounts' : (titles[0] || '')));
        $disc.closest('.cart-discount-list').toggle(discCents > 0).attr('data-td-promo', repOn && discCents > 0 ? '1' : '0');
      }
      if (units === 0) { $row.fadeOut(200); }
    });
    if (repOn) {
      $('.subtotal .theme-money').text(Shopify.formatMoney(repTotal, mf));
    } else {
      $('.subtotal .theme-money').text(Shopify.formatMoney(cart.total_price, mf)); // DN hook class removed Jul 27 — write the h2 span directly
    }
    // 10-26: the sticky phone cart bar was rendered once by Liquid and never repainted — it kept the
    // page-load total and unit count after every stepper edit. Same numbers as the subtotal now.
    $('.td-cartbar__total').text(Shopify.formatMoney(repOn ? repTotal : cart.total_price, mf));
    $('.td-cartbar__units').text(cart.item_count + ' unit' + (cart.item_count !== 1 ? 's' : ''));
    $('.total-unit label').html('Total Units<br><span class="total-unit__n">' + cart.item_count + '</span>');
    // ⚠️ Sep 9 (Jeff: "I removed a few items but the brand breakdown didn't adjust"). The By-brand
    // block is rendered by Liquid from cart.items, so it froze at whatever the page loaded with while
    // the units and subtotal beside it updated — three brands and $537 of stale money next to a
    // $66.72 subtotal. Rebuilt here from the same cart payload, with the same rep-mode rule the rest
    // of this function uses (a rep sees pre-discount wholesale, never their own staff price).
    var $bt = $('.td-brandtotals');
    // ⚠️ Liquid only emits this block for a multi-brand cart, so a cart that STARTED single-brand has
    // no container to repaint into and the summary could never appear (Astra review 09-09). Create it
    // in the same place Liquid would, once it is actually needed.
    if (!$bt.length && cart.items && new Set(cart.items.map(function (i) { return i.vendor || ''; })).size > 1) {
      var $anchor = $('.td-exports').first();
      if ($anchor.length) {
        $bt = $('<div class="td-brandtotals"><span class="td-brandtotals__label">By brand</span></div>').insertBefore($anchor);
      }
    }
    if ($bt.length) {
      var repForBrand = repOn;
      // ⚠️ Object.create(null), not {} (Astra review 09-09): a vendor literally named 'constructor'
      // or '__proto__' resolves through Object.prototype, so `if (!agg[v])` would skip its
      // initialisation and drop the brand — or write onto Object.prototype.
      var order = [], agg = Object.create(null);
      cart.items.forEach(function (it) {
        var v = it.vendor || '';
        if (!agg[v]) { agg[v] = { units: 0, cents: 0 }; order.push(v); }
        agg[v].units += it.quantity;
        agg[v].cents += repForBrand ? window.tdRepLine(it, repPcts) : it.final_line_price;
      });
      // the Liquid only emits this block for a multi-brand order — match that exactly, so removing
      // the last line of a second brand collapses the block instead of leaving a one-row summary
      if (order.length > 1) {
        var html = '';
        order.forEach(function (v) {
          var a = agg[v];
          html += '<div class="row"><span class="b"></span><span class="u">' + a.units +
                  ' unit' + (a.units !== 1 ? 's' : '') + '</span><span class="m">' +
                  Shopify.formatMoney(a.cents, mf) + '</span></div>';
        });
        $bt.find('.row').remove();
        $bt.append(html).show();
        // vendor names are user data — set as text, never interpolated into the html string above
        $bt.find('.row .b').each(function (i) { $(this).text(order[i]); });
      } else {
        $bt.hide();
      }
    }
    if ($('.cart-link__count').length) { $('.cart-link__count').html(cart.item_count); }
    $('.cart-item-list, .checkout-subtotal-container').removeClass('cart-pending');
    if (cart.item_count === 0) { location.reload(); } // let Liquid render the empty-cart state
    scheduleCartSync();
  }

  // ---- DISCOUNT NINJA RE-SYNC (Sep 8). DN's storefront script arms its discount Functions
  // AFTER the page paints (a POST /cart/update.js carrying its attribute), and again ~8s after
  // every cart change — so the numbers Liquid rendered, and the /cart/update.js response we
  // just painted, are both PRE-discount for staff (40%) and promo items. The live theme let
  // DN rewrite the DOM itself; the Trade Desk removed those hooks (Jul 27) in favour of the
  // native discount rows, which left the cart stale until a reload. So: after load and after
  // each edit, poll /cart.js on a settle schedule and repaint from the server whenever its
  // totals move. Read-only; stops by itself once nothing changes. ----
  var lastPainted = { total: null, discount: null, count: null };
  var syncTimers = [];
  function paintedFrom(cart){
    lastPainted = { total: cart.total_price, discount: cart.total_discount, count: cart.item_count };
  }
  function syncCartFromServer(){
    if (cartWorkPending()) return;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(t){
        if (!t || t.charAt(0) !== '{') return;   // a 429 answers with HTML — the next tick retries
        var cart = JSON.parse(t);
        if (cartWorkPending()) return;             // an edit is in flight; its response repaints
        if (cart.total_price === lastPainted.total && cart.total_discount === lastPainted.discount && cart.item_count === lastPainted.count) return;
        if (cart.item_count > 0) applyCartTotals(cart);
      })
      .catch(function(){});
  }
  function scheduleCartSync(){
    syncTimers.forEach(clearTimeout); syncTimers = [];
    [2000, 5000, 9000, 14000].forEach(function(ms){ syncTimers.push(setTimeout(syncCartFromServer, ms)); });
  }
  (function(){
    var $sub = $('.subtotal[data-td-total]');
    if (!$sub.length) return;                      // cart page only
    lastPainted = { total: Number($sub.attr('data-td-total')), discount: Number($sub.attr('data-td-discount')), count: Number($sub.attr('data-td-count')) };
    scheduleCartSync();
  })();

  var cartFlight = 0;                 // how many /cart/update.js calls are in the air

  function flushCartUpdates(){
    var updates = pendingUpdates;
    pendingUpdates = {};
    clearTimeout(cartUpdateTimer);
    if (!Object.keys(updates).length) return $.Deferred().resolve().promise();
    cartFlight++;
    return $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json', data: { updates: updates } })
      .done(applyCartTotals)
      .fail(function(){ location.reload(); }) // fall back to a clean server render on any error
      .always(function(){ cartFlight--; });
  }

  function cartWorkPending(){
    return cartFlight > 0 || Object.keys(pendingUpdates).length > 0;
  }

  function queueCartUpdate(variantId, qty){
    pendingUpdates[variantId] = qty;
    $('.cart-item-list, .checkout-subtotal-container').addClass('cart-pending');
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(flushCartUpdates, 700);
  }

  // ⚠️ CHECKOUT MUST NOT OVERTAKE A PENDING SAVE.
  // Quantity edits debounce 700ms before /cart/update.js, and `cart-pending` only dims some
  // numbers with CSS — nothing stopped the buyer pressing Checkout inside that window. Change
  // 12 units to 20, hit Checkout immediately, and checkout opened with 12: a materially wrong
  // order, silently. The grid inputs are name="quantity", not Shopify `updates[...]`, so the
  // form itself cannot carry the pending edit either.
  // Flush first, then submit the ORIGINAL form. (Codex review, 2026-09-03.)
  var checkoutResuming = false;
  $(document).on('submit', 'form.cart', function (e) {
    if (checkoutResuming || !cartWorkPending()) return;   // nothing outstanding: proceed
    e.preventDefault();
    var form = this;
    var $btns = $(form).find('[name="checkout"]');
    $btns.prop('disabled', true);
    $.when(flushCartUpdates()).always(function () {
      // re-check: a fail path reloads the page, in which case this never runs
      checkoutResuming = true;
      $btns.prop('disabled', false);
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    });
  });

  $(document).on('click', '.cart-item .btnqty', function(e){
    e.preventDefault();
    var $input = $(this).parent('.qtybox').find('.quantity-input');
    var $wrap = $(this).closest('.data-wrap');
    var qty = parseInt($input.val()) || 0;
    var max = parseInt($input.attr('max'));
    if ($(this).hasClass('qtyplus')) {
      if (!isNaN(max) && qty >= max) { flashMax($wrap); return; }
      qty++;
    } else {
      if (qty > 0) { qty--; } else { return; }
    }
    $input.val(qty);
    syncCellState($wrap);
    queueCartUpdate($input.attr('data-variant'), qty);
  });

  // Typed quantities in the cart grid: commit on change (blur/Enter), clamp to
  // available stock, revert anything non-numeric. 0 removes the line (same as
  // stepping down to 0). Feeds the same debounced AJAX save as the steppers.
  $(document).on('focusin', '.cart-item .quantity-input', function(){
    $(this).data('prev', $(this).val());
  });
  $(document).on('keydown', '.cart-item .quantity-input', function(e){
    if (e.key === 'Enter') { e.preventDefault(); $(this).blur(); }
  });
  $(document).on('change', '.cart-item .quantity-input', function(){
    var $input = $(this);
    var $wrap = $input.closest('.data-wrap');
    var raw = String($input.val()).trim();
    var qty = parseInt(raw, 10);
    if (raw === '' || isNaN(qty) || qty < 0) {
      $input.val($input.data('prev') || 0); // invalid input: put it back the way it was
      return;
    }
    var max = parseInt($input.attr('max'));
    if (!isNaN(max) && qty > max) { qty = max; flashMax($wrap); }
    $input.val(qty);
    if (String(qty) === String($input.data('prev'))) { return; } // no actual change
    syncCellState($wrap);
    queueCartUpdate($input.attr('data-variant'), qty);
    $input.data('prev', qty);
  });

  $('.remove-item').on('click', function(e){
    e.preventDefault();
    var groupKey = $(this).attr('data-productID');
    var updates = {};
    var $rows = $('.cart-item[data-product="' + groupKey + '"]');
    $rows.each(function(){ updates[$(this).attr('data-variantid')] = 0; });
    $rows.css('opacity', 0.4);
    $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json', data: { updates: updates } })
      .done(function(cart){ $rows.remove(); applyCartTotals(cart); })
      .fail(function(){ location.reload(); });
  });
  $('.company-info').on('click', function(e){
    e.preventDefault();
    $(this).find('.company-account').slideToggle();
    $(this).find('i').toggleClass('bi-chevron-up');
  })
}); 

/* Old negative-top form-pull sticky hack removed — the buy zone is now a
   fixed bottom action bar (.buy-action-bar). Tuck it away when the footer
   scrolls into view so it never covers the footer. */
/* RECOVERABILITY GUARD (2026-08-25): on a short PDP the footer is already on
   screen at scroll-top, so the old IntersectionObserver docked the bar on load
   and NO scroll position brought it back — Add to Cart was unreachable. Whether
   it broke depended on viewport HEIGHT (fine at 900px, dead at 1200px). Never
   dock when the trigger is already true at scroll-top. */
$(function(){
  var bar = document.querySelector('.buy-action-bar');
  var footer = document.querySelector('#shopify-section-footer, .footer, footer');
  if (!bar || !footer) return;
  var pending = false;
  function sync(){
    pending = false;
    var limit = window.innerHeight - bar.offsetHeight - 40;
    var rect = footer.getBoundingClientRect();
    if (rect.top + window.scrollY < limit) {
      bar.classList.remove('buy-action-bar--docked');
      return;
    }
    bar.classList.toggle('buy-action-bar--docked', rect.top < limit);
  }
  function onScroll(){ if (!pending) { pending = true; requestAnimationFrame(sync); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  sync();
});

var myMenu = $('.navigation__tier-1').children('li.navigation__item--with-children');
myMenu.on({
  mouseenter: function() { $('.overlay').addClass( "is_hovered" ); },
  mouseleave: function() { $('.overlay').removeClass( "is_hovered" ); }
});

$('.navigation__tier-3 li.navigation__item').hover(function(){
    var parent = $(this).find('a').data('parent');
    var get_main =  $('.navigation__tier-1 li').find('[data-main="' + parent + '"]');
    $('.navigation__tier-1 li').removeClass('navigation__item--active');
   $(get_main).closest('li').addClass('navigation__item--active');
});

// if($("#NavigationTier2-1:hover").length != 0){
//             console.log("yes-in");
//         } else{
//             console.log("yes-out");
//         }

// var video_container = $('.video-container').eq(0);

// $(document).on('click',video_container,function(){
//   $('.altcolours')[0].click()
// });

var video_container = $('.video-container').eq(0);
$(video_container).click(function(){
   $('.altcolours')[0].click()
})

$(window).on('load', function(){
  $('.product-list .block-inner .product-block__title').matchHeight();
});

let interval = null;

// let domWorks = () => {
//      let d = document.querySelector('.template-product .price-container')
//      if(d){
//       $('.template-product .price-container .current-price').addClass('hide')
//       clearInterval(interval) // Change it via reference
//      }
// }

// interval = setInterval(domWorks, 100)
document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('.product-list .product-block');

  productCards.forEach(function (card) {
    const brand = card.getAttribute('data-product-brand');
    const rawSku = card.getAttribute('data-product-sku');
    let formattedSku = '';

    if (rawSku) {
      if (brand && brand.toLowerCase() === 'deke') {
        const parts = rawSku.split(" ").filter(Boolean);
        formattedSku = parts.length > 1 ? parts[0] + '-' + parts[1] : parts[0] || '';
      } else {
        formattedSku = rawSku.split(" ")[0];
      }
    }

    const skuElement = card.querySelector('.sku__value');
    if (skuElement) {
      // 08-26: this used to clobber the meta line on EVERY card at DOMContentLoaded, which
      // is why putting the Brax style number there in Liquid appeared to do nothing — the
      // class landed, the text was overwritten a moment later. When Liquid has deliberately
      // put a style number here (.sku__value--style) it is the better identifier: leave it.
      if (!skuElement.classList.contains('sku__value--style')) {
        skuElement.innerHTML = '' + formattedSku;
      }
    }
  });
});
document.addEventListener('variant:change', function(event) {
  var variant = event.detail.variant;
  if (variant) {
    document.querySelector('#selected-inseam').value = variant.option3; // assuming option2 is inseam
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(
    '.clickyboxes.options--in-seam a[data-value="34"]'
  );
  if (el) {
    el.classList.remove("unavailable"); // optional
    el.click();
  }
});

// TTA CSV export — SKU / Brand / Style / Variant / Qty / Unit / Extended from /cart.js
document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('td-export-csv');
  if (!btn) return;
  btn.addEventListener('click', function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var esc = function (v) { v = (v == null ? '' : String(v)); return /[",\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v; };
      var money = function (c) { return (c / 100).toFixed(2); };
      // rep-for orders export the RETAILER's price (wholesale less their promo — what the draft charges),
      // never the rep's staff price (10-26; was pre-discount wholesale)
      var repFor = !!(cart.attributes && cart.attributes['Ordering For Id']);
      var repPcts = window.tdRepPcts(), repTotal = 0;
      var rows = [['SKU', 'Brand', 'Style', 'Variant', 'Qty', 'Unit Wholesale', 'Extended']];
      cart.items.forEach(function (it) {
        var repLine = window.tdRepLine(it, repPcts); repTotal += repLine;
        rows.push([it.sku, it.vendor, it.product_title, (it.variant_title || ''), it.quantity,
          money(repFor ? repLine / it.quantity : it.final_price), money(repFor ? repLine : it.final_line_price)]);
      });
      rows.push([]);
      rows.push(['', '', '', 'TOTAL', cart.item_count, '', money(repFor ? repTotal : cart.total_price)]);
      var csv = rows.map(function (r) { return r.map(esc).join(','); }).join('\r\n');
      var name = (cart.attributes && cart.attributes['Cart Name']) || 'order';
      var d = new Date(), stamp = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      var a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
      a.download = ('TTA-' + name + '-' + stamp).replace(/[^\w.-]+/g, '_') + '.csv';
      document.body.appendChild(a); a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
    });
  });
});

// TTA cart tools — named carts, saved carts, send-a-cart link, SKU quick-entry.
(function () {
  // ⚠️ PER-CUSTOMER. localStorage is origin-wide, so a single shared key leaked one
  // retailer's saved orders to the next person to log in on the same machine — a real
  // scenario at a trade show or in a showroom. Key by customer id.
  var SAVED = 'tta_saved_carts_' + (window.ttaCustomerId || 'anon');
  (function migrateLegacyBucket() {
    // Anything saved before this fix sits under the old shared key. Move it to the CURRENT
    // customer only if they have no bucket yet, then delete the shared one so it can never
    // be read by the next account. Losing a saved cart is far better than showing it to a
    // competitor, so when in doubt this discards rather than merges.
    try {
      var legacy = localStorage.getItem('tta_saved_carts');
      if (!legacy) return;
      if (window.ttaCustomerId && !localStorage.getItem(SAVED)) {
        localStorage.setItem(SAVED, legacy);
      }
      localStorage.removeItem('tta_saved_carts');
    } catch (e) { /* storage blocked — nothing to migrate */ }
  })();
  function saved() { try { return JSON.parse(localStorage.getItem(SAVED) || '[]'); } catch (e) { return []; } }
  function setSaved(a) {
    try { localStorage.setItem(SAVED, JSON.stringify(a.slice(0, 20))); } catch (e) { msg('Could not save — browser storage is full or blocked.'); return false; }
    badge(); return true;
  }
  function badge() {
    var el = document.getElementById('td-saved-count');
    if (el) el.textContent = saved().length ? '(' + saved().length + ')' : '';
  }
  function msg(t, ok) {
    var el = document.getElementById('td-tools-msg');
    if (el) { el.textContent = t || ''; el.classList.toggle('ok', !!ok); }
  }
  function cartJson() { return fetch('/cart.js').then(function (r) { return r.json(); }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }

  // ----- named cart: field syncs to the cart attribute -----
  var nameIn = document.getElementById('td-cart-name');
  if (nameIn) {
    var nt = null;
    nameIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    nameIn.addEventListener('input', function () {
      clearTimeout(nt);
      nt = setTimeout(function () {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Cart Name': nameIn.value.trim() } }) })
          .then(function () { msg(nameIn.value.trim() ? 'Order named.' : '', true); });
      }, 600);
    });
  }

  // ----- save current cart -----
  var saveBtn = document.getElementById('td-save-cart');
  if (saveBtn) saveBtn.addEventListener('click', function () {
    cartJson().then(function (c) {
      if (!c.items.length) { msg('Nothing to save — cart is empty.'); return; }
      var name = (nameIn && nameIn.value.trim()) || (c.attributes && c.attributes['Cart Name']) || 'Order ' + new Date().toLocaleDateString();
      var a = saved().filter(function (s) { return s.name !== name; });
      a.unshift({ name: name, items: c.items.map(function (it) { return { id: it.variant_id, quantity: it.quantity }; }),
        units: c.item_count, total: c.total_price, savedAt: Date.now() });
      if (setSaved(a)) msg('Saved “' + name + '” — find it under Saved.', true);
    });
  });

  // ----- saved list -----
  var toggle = document.getElementById('td-saved-toggle');
  var list = document.getElementById('td-savedlist');
  function renderList() {
    if (!list) return;
    var a = saved();
    list.innerHTML = '';
    if (!a.length) { var d = document.createElement('div'); d.className = 'empty'; d.textContent = 'No saved carts yet — build an order and hit Save cart.'; list.appendChild(d); return; }
    a.forEach(function (s, i) {
      var row = document.createElement('div'); row.className = 'srow';
      var l = document.createElement('div'); l.className = 'l';
      var b = document.createElement('b'); b.textContent = s.name; l.appendChild(b);
      var meta = document.createElement('span');
      meta.textContent = s.units + ' units · ' + money(s.total) + ' · ' + new Date(s.savedAt).toLocaleDateString();
      meta.className = 'meta'; l.appendChild(meta);
      row.appendChild(l);
      var acts = document.createElement('div'); acts.className = 'r';
      var load = document.createElement('button'); load.type = 'button'; load.className = 'td-btn td-btn--red'; load.textContent = 'Load';
      load.addEventListener('click', function () { loadSaved(s); });
      var del = document.createElement('button'); del.type = 'button'; del.className = 'td-btn td-btn--ghost'; del.textContent = '✕';
      del.setAttribute('aria-label', 'Delete ' + s.name);
      del.addEventListener('click', function () { var b2 = saved(); b2.splice(i, 1); setSaved(b2); renderList(); });
      acts.appendChild(load); acts.appendChild(del);
      row.appendChild(acts);
      list.appendChild(row);
    });
  }
  if (toggle) toggle.addEventListener('click', function () { renderList(); list.hidden = !list.hidden; });

  function loadSaved(s) {
    cartJson().then(function (c) {
      if (c.items.length && !confirm('Replace the current cart (' + c.item_count + ' units) with “' + s.name + '”?')) return;
      msg('Loading “' + s.name + '”…');
      var p = fetch('/cart/clear.js', { method: 'POST' });
      var failed = 0;
      s.items.forEach(function (it) {
        p = p.then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: it.id, quantity: it.quantity }) })
            .then(function (r) { if (!r.ok) failed++; })
            .then(function () { return new Promise(function (res) { setTimeout(res, 450); }); });
        });
      });
      p.then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Cart Name': s.name } }) });
      }).then(function () {
        if (failed) alert(failed + ' line(s) could not be re-added (likely sold out) — the rest loaded.');
        location.href = '/cart';
      }).catch(function () {
        msg('Load hit a network error — check the cart before continuing.');
        setTimeout(function () { location.href = '/cart'; }, 1400);
      });
    });
  }

  // ----- reorder (account + order pages): re-add a past order's lines -----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.td-reorder');
    if (!btn) return;
    e.preventDefault();
    var lines;
    try { lines = JSON.parse(btn.getAttribute('data-td-reorder') || '[]'); } catch (err) { lines = []; }
    if (!lines.length) return;
    var oname = btn.getAttribute('data-order-name') || 'past order';
    if (!confirm('Add the ' + lines.length + ' line(s) from ' + oname + ' to your cart? Out-of-stock sizes are skipped.')) return;
    btn.disabled = true; btn.textContent = 'Adding…';
    var failed = 0, p2 = Promise.resolve();
    lines.forEach(function (it) {
      p2 = p2.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.id, quantity: it.q }) })
          .then(function (r) { if (!r.ok) failed++; })
          .then(function () { return new Promise(function (res) { setTimeout(res, 450); }); });
      });
    });
    p2.then(function () {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Cart Name': 'Reorder ' + oname } }) });
    }).then(function () {
      if (failed) alert(failed + ' line(s) skipped (no longer available) — everything else is in the cart.');
      location.href = '/cart';
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Reorder';
      alert('Network hiccup while re-adding — check your cart before retrying.');
    });
  });

  // ----- send-a-cart (share link) -----
  var share = document.getElementById('td-share-cart');
  if (share) share.addEventListener('click', function () {
    cartJson().then(function (c) {
      if (!c.items.length) { msg('Cart is empty — nothing to share.'); return; }
      var pairs = c.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(',');
      // storefront=true lands the recipient on the CART PAGE to review — a bare
      // permalink would shove them straight into checkout with a replaced cart
      var url = location.origin + '/cart/' + pairs + '?storefront=true';
      var name = (c.attributes && c.attributes['Cart Name']) || '';
      if (name) url += '&' + encodeURIComponent('attributes[Cart Name]') + '=' + encodeURIComponent(name);
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject())
        .then(function () {
          share.textContent = 'Link copied ✓';
          msg('Share link copied — anyone with portal access opens this exact order.', true);
          setTimeout(function () { share.textContent = 'Copy share link'; }, 3000);
        })
        .catch(function () { prompt('Copy this link:', url); });
    });
  });

  // ----- SKU quick-entry -----
  var skuBtn = document.getElementById('td-sku-add');
  var skuIn = document.getElementById('td-sku-in');
  var skuBusy = false;
  function norm(s) { return String(s || '').replace(/\s+/g, '').toUpperCase(); }
  function skuDone() { skuBusy = false; if (skuBtn) skuBtn.disabled = false; }
  function skuAdd() {
    if (skuBusy) return;
    var q = (skuIn.value || '').trim();
    var qty = Math.max(1, parseInt((document.getElementById('td-sku-qty') || {}).value) || 1);
    if (q.length < 3) { msg('Type at least 3 characters of the SKU.'); return; }
    skuBusy = true; if (skuBtn) skuBtn.disabled = true;
    msg('Looking up ' + q + '…');
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[options][fields]=variants.sku&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var prods = (j.resources && j.resources.results && j.resources.results.products) || [];
        if (!prods.length) { msg('No style found for “' + q + '”.'); return; }
        // fetch full product data to match the exact variant
        return Promise.all(prods.slice(0, 6).map(function (pr) {
          return fetch(pr.url.split('?')[0] + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (full) {
          var nq = norm(q), exact = [], partialProducts = [];
          full.filter(Boolean).forEach(function (prod) {
            var hit = prod.variants.filter(function (v) { return norm(v.sku) === nq; });
            if (hit.length) exact.push({ prod: prod, v: hit[0] });
            else if (prod.variants.some(function (v) { return norm(v.sku).indexOf(nq) === 0; })) partialProducts.push(prod);
          });
          if (exact.length) {
            var pick = exact[0];
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: pick.v.id, quantity: qty }) })
              .then(function (r) {
                if (r.ok) { msg('Added ' + qty + ' × ' + pick.prod.title + '.', true); skuIn.value = ''; setTimeout(function () { location.reload(); }, 900); }
                else return r.json().then(function (e) { msg(e.description || 'Could not add — check stock.'); });
              });
          }
          if (partialProducts.length === 1) {
            msg('Found ' + partialProducts[0].title + ' — opening it to pick sizes…', true);
            setTimeout(function () { location.href = '/products/' + partialProducts[0].handle; }, 700);
            return;
          }
          msg(partialProducts.length > 1 ? 'Several styles match — add more of the SKU.' : 'No exact SKU match — check the number.');
        });
      })
      .then(skuDone)
      .catch(function () { msg('Lookup failed — try again.'); skuDone(); });
  }
  if (skuBtn) skuBtn.addEventListener('click', skuAdd);
  if (skuIn) skuIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); skuAdd(); } });
  var skuQty = document.getElementById('td-sku-qty');
  if (skuQty) skuQty.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); skuAdd(); } });

  document.addEventListener('DOMContentLoaded', badge);

  // homepage quick-action deep links: /cart?open=saved and /cart?focus=sku
  document.addEventListener('DOMContentLoaded', function () {
    var qp = new URLSearchParams(location.search);
    if (qp.get('open') === 'saved' && toggle) { renderList(); if (list) list.hidden = false; toggle.scrollIntoView({ block: 'center' }); }
    if (qp.get('focus') === 'sku' && skuIn) { skuIn.scrollIntoView({ block: 'center' }); setTimeout(function () { skuIn.focus(); }, 300); }
  });

  // dashboard "Save & start a new order": snapshot the open cart into Saved, then clear
  var startNew = document.getElementById('td-start-new');
  if (startNew) startNew.addEventListener('click', function () {
    cartJson().then(function (c) {
      if (!c.items.length) { location.reload(); return; }
      var name = (c.attributes && c.attributes['Cart Name']) || 'Order ' + new Date().toLocaleDateString();
      if (!confirm('Save “' + name + '” (' + c.item_count + ' units) to your Saved carts and start fresh?')) return;
      var a = saved().filter(function (s) { return s.name !== name; });
      a.unshift({ name: name, items: c.items.map(function (it) { return { id: it.variant_id, quantity: it.quantity }; }),
        units: c.item_count, total: c.total_price, savedAt: Date.now() });
      if (!setSaved(a)) return;
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Cart Name': '' } }) }); })
        .then(function () { location.reload(); });
    });
  });
})();

// TTA booking lane guard — a mixed cart can't check out (bookings bulk to the
// factory; repeats ship now). Applies to self-checkout AND rep actions.
function ttaLaneGuard() {
  if (!document.getElementById('td-lane-mixed')) return;
  ['update-cart', 'td-rep-place', 'td-rep-quote', 'td-rep-send'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) { el.disabled = true; el.style.opacity = '.4'; el.style.pointerEvents = 'none'; el.title = 'Split the booking and in-season items first'; }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ttaLaneGuard);
else ttaLaneGuard();

// TTA Market Pulse — fill Top Movers + Going Fast from the best-selling source
// (Section Rendering API honours sort_by server-side; no admin writes needed).
function ttaInitMarketPulse() {
  var movers = document.getElementById('td-movers');
  var fast = document.getElementById('td-goingfast');
  if (!movers && !fast) return;
  // Source is gender-scoped server-side (see sections/tta-market-pulse.liquid): a
  // womenswear-only book reads /collections/womens, a menswear-only book /collections/mens,
  // and a mixed or unrecognised book still reads the whole platform. Falls back to
  // /collections/all if the attribute is missing, so an older cached section still works.
  var moversSrc = (movers && movers.getAttribute('data-src')) || '/collections/all';
  fetch(moversSrc + '?sort_by=best-selling&sections=tta-src-bestsellers')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      if (!j) return;
      var doc = new DOMParser().parseFromString(j['tta-src-bestsellers'] || '', 'text/html');
      var raw = doc.querySelector('[data-tta-bestsellers]');
      var items = [];
      try { items = JSON.parse(raw ? raw.textContent : '[]'); } catch (e) { items = []; }
      if (!items.length) return;

      function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      function card(it, chipText, chipClass) {
        var a = document.createElement('a');
        a.className = 'td-pcard';
        a.href = it.url;
        var ph = document.createElement('div'); ph.className = 'ph';
        if (it.img) { var img = document.createElement('img'); img.loading = 'lazy'; img.src = it.img; img.alt = it.title; ph.appendChild(img); }
        // Audit 08-25: Top movers was the ONLY shelf a buyer could not batch-tick, so the
        // one shelf about what everyone else is buying could not feed the sizing queue.
        if (document.body.classList.contains('td-customer') || document.querySelector('[data-td-quickadd]')) {
          var qa = document.createElement('button');
          qa.type = 'button'; qa.className = 'td-quickadd';
          qa.setAttribute('data-td-quickadd',''); qa.setAttribute('aria-pressed','false');
          qa.setAttribute('data-url', it.url); qa.setAttribute('data-handle', it.handle || '');
          qa.setAttribute('data-title', it.title || ''); qa.setAttribute('data-img', it.img || '');
          qa.setAttribute('aria-label', 'Select ' + (it.title || '') + ' for batch sizing');
          qa.innerHTML = '<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true"><path d="M2 7.5 5.5 11 12 3.5" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
          ph.appendChild(qa);
        }
        a.appendChild(ph);
        var meta = document.createElement('div'); meta.className = 'meta';
        // Audit 08-25: this was the only shelf printing a raw SKU in the eyebrow
        // ("EMANUEL BERG · MJ414918BY") while every other shelf shows a clean brand line.
        meta.textContent = it.vendor || '';
        a.appendChild(meta);
        var h = document.createElement('h4'); h.textContent = it.title; a.appendChild(h);
        var price = document.createElement('div'); price.className = 'price';
        // Sep 15: staff pricing on this shelf too (Jeff: "my discount … not the homepage") —
        // same markup/rounding/rep-mode classes as every other card (ttaStaffPriceMarkup).
        var staffHtml = ttaStaffPriceMarkup(it.price, money);
        if (staffHtml) {
          price.innerHTML = staffHtml;
        } else {
          var span = document.createElement('span'); span.className = 'td-money-hidable'; span.textContent = money(it.price);
          price.appendChild(span);
          if (it.msrp > it.price) { var sm = document.createElement('small'); sm.textContent = money(it.msrp) + ' MSRP'; price.appendChild(sm); }
        }
        a.appendChild(price);
        var chip = document.createElement('span');
        chip.className = 'td-chip' + (chipClass ? ' ' + chipClass : '');
        chip.style.marginTop = '8px';
        var dot = document.createElement('span'); dot.className = 'td-dot'; chip.appendChild(dot);
        chip.appendChild(document.createTextNode(' ' + chipText));
        a.appendChild(chip);
        return a;
      }
      function fill(el, list, chipFor) {
        if (!el) return;
        el.innerHTML = '';
        list.forEach(function (it) { var c = chipFor(it); el.appendChild(card(it, c.t, c.k)); });
      }

      var n = parseInt(movers && movers.getAttribute('data-count')) || 4;
      var moverList = items.slice(0, n);
      fill(movers, moverList, function (it) {
        return it.availSizes <= 3 ? { t: it.availSizes + ' size' + (it.availSizes === 1 ? '' : 's') + ' left', k: 'td-chip--low' } : { t: 'In stock', k: '' };
      });

      var maxSizes = parseInt(fast && fast.getAttribute('data-max-sizes')) || 3;
      var used = {};
      moverList.forEach(function (it) { used[it.handle] = true; });
      var fastList = items.filter(function (it) { return !used[it.handle] && it.availSizes > 0 && it.availSizes <= maxSizes; }).slice(0, n);
      if (fastList.length) {
        fill(fast, fastList, function (it) {
          return { t: it.availSizes + ' size' + (it.availSizes === 1 ? '' : 's') + ' left', k: 'td-chip--low' };
        });
      } else if (fast) {
        // nothing thinning right now — hide the block + its heading
        var head = fast.previousElementSibling;
        fast.hidden = true;
        if (head && head.classList.contains('td-sechead')) head.hidden = true;
      }
    })
    .catch(function () {});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ttaInitMarketPulse);
else ttaInitMarketPulse();

// TTA sellable-only policy: buyers never see sold-out goods outside a booking
// lane. Collections + search auto-apply the native availability filter when
// the buyer lands without any filter params (mode chips still let them refine).
(function () {
  var path = location.pathname;
  var isCollection = /^\/collections\/[^/]+\/?$/.test(path) && !/\/products\//.test(path);
  var isSearch = path === '/search';
  if (!isCollection && !isSearch) return;
  var qs = new URLSearchParams(location.search);
  // ⚠️ This used to bail on ANY filter. param, which meant the sellable-only policy was
  // silently skipped for every inbound link that already carried a filter — e.g. a
  // ?filter.p.m.custom.category=Denim link landed with NO availability constraint and
  // showed sold-out goods until the buyer touched the drawer. Only bail when the
  // availability decision has actually been made.
  if (qs.has('filter.v.availability')) return;
  if (isSearch && !qs.get('q')) return; // empty search page: nothing to filter
  qs.set('filter.v.availability', '1');
  var newUrl = path + '?' + qs.toString();

  // 09-05: apply IN PLACE on collections instead of location.replace().
  // The reload meant every bare collection URL loaded the whole page twice — HTML,
  // CSS, JS, fonts and 40 images — and Lighthouse scored it as an 8.7s redirect on
  // mobile (collection perf 55). The theme's own AJAX filter loader
  // (theme.CollectionTemplateSection, enabled by data-ajax-filtering) swaps the rail,
  // grid and pagination from a fetch and listens for popstate. So: rewrite the URL,
  // fire popstate, and let it do the same work without a second page load.
  // main-collection.liquid already skips sold-out products on the first paint, so
  // nothing unsellable flashes while the fetch lands. Search keeps the reload —
  // its results are small and its template has no AJAX loader.
  var sec = isCollection && document.querySelector('[data-section-type="collection-template"][data-ajax-filtering="true"]');
  if (!sec || !window.history || !history.replaceState || typeof PopStateEvent !== 'function' || !window.MutationObserver) {
    location.replace(newUrl);
    return;
  }
  function apply() {
    var seen = false;
    var mo = new MutationObserver(function () {
      if (document.querySelector('[data-ajax-container].ajax-loading')) { seen = true; mo.disconnect(); }
    });
    var containers = document.querySelectorAll('[data-ajax-container]');
    if (!containers.length) { location.replace(newUrl); return; }
    Array.prototype.forEach.call(containers, function (el) { mo.observe(el, { attributes: true, attributeFilter: ['class'] }); });
    try { history.replaceState({ path: location.origin + newUrl }, '', newUrl); }
    catch (e) { location.replace(newUrl); return; }
    // The loader pushes its URL onto history. That would leave [bare, filtered] and
    // make Back land on the unfiltered page; make that one push a replace so the
    // history reads exactly as it did with location.replace().
    var origPush = history.pushState;
    history.pushState = function (s, t, u) { return history.replaceState(s, t, u); };
    try { window.dispatchEvent(new PopStateEvent('popstate', { state: { path: location.origin + newUrl } })); }
    finally { setTimeout(function () { history.pushState = origPush; }, 0); }
    // No listener (theme.js not initialised, or ajax disabled after all) -> nothing
    // ever goes into the loading state -> take the old road rather than leave a
    // URL that promises a filter the grid does not have.
    setTimeout(function () { if (!seen) { mo.disconnect(); location.replace(newUrl); } }, 1500);
  }
  // theme.js registers the section (and its popstate listener) on DOMContentLoaded;
  // run after that, never before.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(apply, 0); });
  } else {
    setTimeout(apply, 0);
  }
})();

// TTA colourway stock dots — the other-colours strip shows availability depth
// per sibling (green = good size run, amber = thin, grey = sold out).
function ttaInitCwDots() {
  // The theme populates the strip TWICE (quick pass, then re-render after its
  // search roundtrip) and replaces the nodes each time — so cache the VERDICT
  // per sibling href and re-apply it to whatever nodes currently exist.
  if (!document.querySelector('.related-items-cont')) return;
  var verdict = {}; // href -> 'cw-in'|'cw-low'|'cw-out' | Promise (in flight)
  function applyAll() {
    document.querySelectorAll('.related-items li a[href*="/products/"]').forEach(function (a) {
      // 09-05 a11y: the strip is built by the theme's search roundtrip with bare <img>
      // tags (no alt at all — Lighthouse image-alt). Name them from the link.
      Array.prototype.forEach.call(a.querySelectorAll('img:not([alt])'), function (img) {
        img.alt = (a.getAttribute('title') || a.textContent || 'Colourway').replace(/\s+/g, ' ').trim();
      });
      var href = (a.getAttribute('href') || '').split('?')[0];
      var v = verdict[href];
      if (typeof v === 'string') {
        var li = a.closest('li');
        if (li && !li.classList.contains(v)) li.classList.add(v);
      }
    });
  }
  function enrich() {
    document.querySelectorAll('.related-items li a[href*="/products/"]').forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0];
      if (!href || verdict[href]) return;
      verdict[href] = fetch(href + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod) { delete verdict[href]; return; }
          var availSizes = prod.variants.filter(function (v) { return v.available; }).length;
          verdict[href] = availSizes === 0 ? 'cw-out' : (availSizes <= 3 ? 'cw-low' : 'cw-in');
          applyAll();
        })
        .catch(function () { delete verdict[href]; });
    });
    applyAll();
  }
  new MutationObserver(enrich).observe(document.body, { childList: true, subtree: true });
  enrich();
}
// script may execute before OR after DOMContentLoaded depending on load strategy
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ttaInitCwDots);
else ttaInitCwDots();


// TTA quick-add batch flow — checkmark styles on the line sheet, size them one
// after another on the PDP (queue in sessionStorage; survives navigation).
(function () {
  var KEY = 'tta_batch', ACTIVE = 'tta_batch_active';
  function get() { try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function set(a) { sessionStorage.setItem(KEY, JSON.stringify(a)); paint(); }

  function keyOf(x) { return x.handle || x.url; } // handle = product identity (same style in 2 collections ≠ dupes)

  // Published so other features can feed the same queue instead of inventing a second one.
  // Scan-to-reorder (V2.5) uses this; the dedupe and the sessionStorage shape stay owned here.
  window.ttaBatch = {
    get: get,
    keyOf: keyOf,
    add: function (item) {
      if (!item || !item.url || !/^\/products\//.test(item.url)) return false;
      var a = get();
      if (a.some(function (y) { return keyOf(y) === keyOf(item); })) return false;
      a.push(item); set(a); return true;
    },
    count: function () { return get().length; },
    start: function () {
      var q = get();
      if (!q.length) return;
      sessionStorage.setItem(ACTIVE, '1');
      location.href = q[0].url;
    }
  };
  function dispTitle(t) { return (t || '').replace(/^\([^)]*\)\s*/, ''); } // mirror td-display-title: strip "(code) " prefix
  function paint() {
    var a = get();
    document.querySelectorAll('[data-td-quickadd]').forEach(function (b) {
      var k = b.getAttribute('data-handle') || b.getAttribute('data-url');
      var on = a.some(function (x) { return keyOf(x) === k; });
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var bar = document.getElementById('td-batchbar');
    if (bar) {
      bar.hidden = a.length === 0;
      // reserve page space so the fixed bar never lands on top of content (audit 08-25)
      document.body.classList.toggle('td-batch-open', a.length > 0);
      var c = bar.querySelector('[data-td-batch-count]'); if (c) c.textContent = a.length;
      var p = bar.querySelector('[data-td-batch-plural]'); if (p) p.textContent = a.length === 1 ? '' : 's';
      // verb-first CTA: "SIZE 3 STYLES →" (Jeff 08-20: the old noun label didn't pop)
      var goBtn = bar.querySelector('[data-td-batch-go]');
      if (goBtn) goBtn.textContent = 'Size ' + a.length + ' style' + (a.length === 1 ? '' : 's') + ' →';
      // thumbnails of the picked styles inside the bar
      var strip = bar.querySelector('.td-batch-thumbs');
      if (strip) {
        strip.textContent = '';
        a.slice(0, 8).forEach(function (x) { strip.appendChild(thumbEl(x, '')); });
        if (a.length > 8) { var more = document.createElement('span'); more.className = 'td-thumb-more'; more.textContent = '+' + (a.length - 8); strip.appendChild(more); }
      }
      liftAbovePreviewBar(bar, 0);
    }
  }

  // small style thumbnail (img when captured, initial-letter box for legacy queue items)
  function thumbEl(x, state) {
    var el;
    if (x.img) { el = document.createElement('img'); el.src = x.img; el.alt = ''; }
    else { el = document.createElement('span'); el.textContent = (x.title || '?').charAt(0); }
    el.className = 'td-thumb' + (state ? ' is-' + state : '');
    el.title = dispTitle(x.title);
    return el;
  }

  // Shopify's draft-preview toolbar overlays the bottom of the viewport and
  // swallows clicks on anything under it — lift our fixed bars above it.
  // The wrapper is injected ASYNC after load, so re-measure until it appears.
  var ttaLifted = [];
  function liftAbovePreviewBar(el, base) {
    if (!el) return;
    ttaLifted.push([el, base]);
    applyLift(el, base);
  }
  function applyLift(el, base) {
    var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    var h = pb ? Math.max(44, pb.getBoundingClientRect().height || 48) : 0;
    el.style.bottom = (base + h) + 'px';
  }
  (function watchPreviewBar() {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      if (pb) { ttaLifted.forEach(function (x) { applyLift(x[0], x[1]); }); clearInterval(iv); }
      else if (tries > 20) clearInterval(iv); // published theme: no bar, stop looking
    }, 500);
  })();

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-td-quickadd]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var k = b.getAttribute('data-handle') || b.getAttribute('data-url');
      var a = get();
      var i = a.findIndex(function (x) { return keyOf(x) === k; });
      if (i >= 0) a.splice(i, 1);
      else a.push({ url: b.getAttribute('data-url'), handle: b.getAttribute('data-handle') || '', title: b.getAttribute('data-title') || '', img: b.getAttribute('data-img') || '' });
      set(a);
      return;
    }
    // Capsule "Select all N" (Aug 25). Adds a whole story's styles to the queue in one
    // press and DELIBERATELY does not navigate — the buyer still starts the run from the
    // sticky bar, so they keep the chance to deselect. Idempotent: pressing twice must
    // leave the queue at N, not 2N, so dedupe on keyOf exactly like the single-add path.
    var many = e.target.closest('[data-td-batch-addmany]');
    if (many) {
      e.preventDefault(); e.stopPropagation();
      var items = [];
      try { items = JSON.parse(many.getAttribute('data-items') || '[]'); } catch (err) { items = []; }
      // pdpQueue() matches on /products/<handle>; a collection URL would no-op the rail
      // silently, with no error to notice. Drop anything that isn't a real PDP.
      items = items.filter(function (x) { return x && x.url && /^\/products\//.test(x.url); });
      if (!items.length) return;
      var q = get();
      items.forEach(function (x) {
        if (!q.some(function (y) { return keyOf(y) === keyOf(x); })) q.push(x);
      });
      set(q);
      many.classList.add('is-added');
      var lbl = many.querySelector('[data-td-addmany-label]');
      if (lbl) lbl.textContent = 'Added to your run';
      return;
    }
    if (e.target.closest('[data-td-batch-clear]')) { sessionStorage.removeItem(ACTIVE); set([]); return; }
    if (e.target.closest('[data-td-batch-go]')) {
      var q = get();
      if (q.length) { sessionStorage.setItem(ACTIVE, '1'); location.href = q[0].url; }
    }
  });

  // PDP: guided sizing run while a batch is active (Jeff 08-20: "super simple and
  // idiot proof"). Full-width queue rail + the NATIVE Add-to-Cart auto-advances --
  // the old trap was that only the little chip link advanced, so clicking the real
  // ATC stranded you on the page.
  function pdpQueue() {
    if (!document.querySelector('.buy-action-bar') || document.getElementById('td-queue')) return;
    if (sessionStorage.getItem(ACTIVE) !== '1') return;
    var a = get();
    if (!a.length) return;
    var path = location.pathname;
    var idx = a.findIndex(function (x) {
      if (x.handle) return path.indexOf('/products/' + x.handle) !== -1;
      return (x.url || '').split('?')[0] === path;
    });
    if (idx < 0) return;
    var next = a[idx + 1];
    var isLast = !next;
    var nextHref = next ? next.url : '/cart';
    var advancing = false; // one advance per page, no double-fires

    var rail = document.createElement('div');
    rail.className = 'td-queue'; rail.id = 'td-queue';

    // left: progress + clickable thumbnails (done / current / upcoming)
    var left = document.createElement('div'); left.className = 'td-queue-left';
    var prog = document.createElement('span'); prog.className = 'td-queue-prog';
    var pb = document.createElement('b'); pb.textContent = 'Sizing ' + (idx + 1) + ' of ' + a.length;
    prog.appendChild(pb);
    left.appendChild(prog);
    var strip = document.createElement('div'); strip.className = 'td-queue-thumbs';
    a.forEach(function (x, i) {
      var t = thumbEl(x, i < idx ? 'done' : (i === idx ? 'current' : ''));
      if (i !== idx) { // forgiving: tap any style in the strip to jump straight to it
        t.style.cursor = 'pointer';
        t.addEventListener('click', function () { location.href = x.url; });
      }
      strip.appendChild(t);
    });
    left.appendChild(strip);
    rail.appendChild(left);

    // right: ONE truthful primary button + a quiet exit
    var right = document.createElement('div'); right.className = 'td-queue-right';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'td-btn td-btn--red td-queue-go'; btn.id = 'td-batch-adv';
    var exit = document.createElement('a');
    exit.href = '#'; exit.className = 'td-queue-exit'; exit.textContent = 'Exit sizing';
    exit.addEventListener('click', function (e) {
      e.preventDefault();
      sessionStorage.removeItem(ACTIVE); sessionStorage.removeItem(KEY);
      rail.remove(); paint();
    });
    right.appendChild(exit); right.appendChild(btn);
    rail.appendChild(right);

    function unitCount() {
      var units = 0;
      document.querySelectorAll('.product-detail .v-table-main .data-wrap .quantity-input').forEach(function (i) {
        units += parseInt(i.value, 10) > 0 ? parseInt(i.value, 10) : 0;
      });
      return units;
    }
    // Jeff 07-27: never silently drop sized-but-unadded units -- the label tells the
    // truth about exactly what the click will do.
    function refreshBtn() {
      var units = unitCount();
      var tail = isLast ? 'Review order →' : 'Next style →';
      // ⚠️ Sep 9 (Jeff, mobile): "Skip → <next style title>" ran to 321px on a 390px screen and
      // painted straight over "Sizing 1 of 3". The title is redundant on a phone anyway — the
      // thumbnail strip beside the counter already shows what is next. Measured, not guessed.
      var narrow = window.matchMedia('(max-width: 767px)').matches;
      var skip = isLast ? 'Review order →'
        : (narrow ? 'Skip → next style'
                  : 'Skip → ' + ((next && next.title) ? dispTitle(next.title).slice(0, 28) : 'next style'));
      btn.textContent = units > 0
        ? ('Add ' + units + ' unit' + (units === 1 ? '' : 's') + ' · ' + tail)
        : skip;
      return units;
    }
    refreshBtn();
    // rotating a phone changes which label fits
    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 767px)');
      if (mq.addEventListener) { mq.addEventListener('change', refreshBtn); }
      else if (mq.addListener) { mq.addListener(refreshBtn); }
    }
    document.addEventListener('input', function (e) { if (e.target.classList && e.target.classList.contains('quantity-input')) refreshBtn(); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.product-detail .btnqty, .v-table-col-main')) setTimeout(refreshBtn, 60); });

    function toast(msg) {
      var t = document.createElement('div');
      t.className = 'td-queue-toast'; t.textContent = msg;
      document.body.appendChild(t);
      // ⚠️ Sep 9 (Jeff, mobile): the toast was pinned at a hard bottom:150px, which on a phone put
      // it straight across the sizing rail AND the buy bar — three stacked bars, the toast's second
      // line hidden behind one of them. Measure the rail and sit above it instead. The rail's own
      // height varies with the thumbnail strip, so this cannot be a constant.
      var above = document.getElementById('td-queue') || document.querySelector('.buy-action-bar');
      if (above) {
        var r = above.getBoundingClientRect();
        t.style.bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
      }
      setTimeout(function () { t.classList.add('is-out'); }, 1400);
      setTimeout(function () { t.remove(); }, 2000);
    }
    function advance() {
      if (advancing) return;
      advancing = true;
      if (isLast) { sessionStorage.removeItem(ACTIVE); sessionStorage.removeItem(KEY); }
      // brief beat so the "added" feedback is perceived before the page turns
      toast(isLast ? 'All sized — taking you to your order' : 'Next: ' + ((next && next.title) ? dispTitle(next.title) : 'next style'));
      setTimeout(function () { location.href = nextHref; }, 900);
    }
    function watchAtcThenAdvance(atc) {
      var t0 = Date.now();
      var iv = setInterval(function () {
        if (!atc.classList.contains('atc-busy')) {
          clearInterval(iv);
          setTimeout(advance, 500); // let the booking-attr stamp + badge refresh land
        } else if (Date.now() - t0 > 9000) {
          clearInterval(iv); advancing = false; // add stuck -- stay put, lose nothing
        }
      }, 250);
    }

    btn.addEventListener('click', function () {
      var units = refreshBtn();
      var atc = document.getElementById('atc-btn');
      if (units === 0 || !atc) { advance(); return; }
      if (!atc.classList.contains('atc-busy')) atc.click(); // full ATC flow (update-vs-add, booking attr, toast)
      watchAtcThenAdvance(atc);
    });

    // THE FIX (Jeff 08-20): the native Add-to-Cart button also advances the run.
    var nativeAtc = document.getElementById('atc-btn');
    if (nativeAtc) {
      nativeAtc.addEventListener('click', function () {
        if (advancing) return;                       // a watcher is already running
        // idle now means "nothing to submit" — a click there posts nothing, so there is no
        // add to watch for and the run must not advance past this style.
        if (nativeAtc.classList.contains('td-atc-idle')) return;
        if (unitCount() === 0) return;
        watchAtcThenAdvance(nativeAtc);
      });
    }

    document.body.appendChild(rail);
    // Jeff 08-25: the queue bar hardcoded a 76px buy-bar height while the real bar is 60px,
    // leaving a ~16px strip of page showing between the two fixed bars — the "transparent
    // ribbon". Measure the bar we are stacking on instead of assuming its height.
    var buyBar = document.querySelector('.buy-action-bar');
    var buyH = buyBar ? Math.round(buyBar.getBoundingClientRect().height) : (window.innerWidth < 768 ? 96 : 76);
    liftAbovePreviewBar(rail, buyH);
    // Keep the queue rail flush with whatever the buy bar is doing.
    // TWO things move it: the viewport (height changes), and DOCKING — a peer session's
    // fix (f09f8ba) slides the buy bar away with translateY(110%) once the footer is in
    // view. offsetHeight still reports 60 when it is translated, so without watching the
    // CLASS the rail stayed 128px up and floated over an empty strip at the footer —
    // measured. Same defect class as the ribbon Jeff reported, different trigger.
    function railBase() {
      if (!buyBar) return window.innerWidth < 768 ? 96 : 76;
      if (buyBar.classList.contains('buy-action-bar--docked')) return 0;
      return Math.round(buyBar.getBoundingClientRect().height) || 60;
    }
    function syncRail() {
      var b = railBase();
      ttaLifted.forEach(function (x) { if (x[0] === rail) x[1] = b; });
      applyLift(rail, b);
    }
    if (buyBar) {
      if (window.ResizeObserver) new ResizeObserver(syncRail).observe(buyBar);
      if (window.MutationObserver) {
        new MutationObserver(syncRail).observe(buyBar, { attributes: true, attributeFilter: ['class'] });
      }
      window.addEventListener('scroll', syncRail, { passive: true });
      syncRail();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    paint(); pdpQueue();
    // the PDP buy bar is fixed to the viewport bottom — lift it too on draft previews
    liftAbovePreviewBar(document.querySelector('.buy-action-bar'), 0);
  });
  // theme ajax (filter/sort/pagination) swaps the grid HTML — re-sync check states
  if (window.jQuery) jQuery(document).on('cc:component:load', function () { paint(); });
})();

// AAA Jul 27: pin the PDP info column beside long galleries — but only when it FITS the
// viewport; a taller-than-viewport column pinned by pure CSS strands its lower half.
(function () {
  function tdStickyDetail() {
    var el = document.querySelector('.product-detail .product-column-right.sticky-content-container');
    if (!el) return;
    el.classList.toggle('td-sticky-on', el.offsetHeight < window.innerHeight - 140);
  }
  window.addEventListener('load', tdStickyDetail);
  window.addEventListener('resize', tdStickyDetail);
  document.addEventListener('DOMContentLoaded', function () { setTimeout(tdStickyDetail, 800); });
})();

// Sep 15 (Jeff: "when I was logged in as staff, my discount shows on collection pages, PDP,
// cart… but not the homepage"). The ONE client-side staff price block, for every card the
// browser builds or reprices (profile shelves, Market Pulse). Liquid cards get the same markup
// from snippets/tta-card-price.liquid. theme.liquid emits the viewer's account-level rate on
// body[data-tta-staff-pct] — 0 unless staff, and 0 whenever the cart carries 'Ordering For Id'.
// Rounding matches the Liquid and the cart: the DISCOUNT is truncated, then subtracted. Staff
// figures carry .tta-rep-hide.tta-staff-only (hidden under html.td-rep-on); the
// .tta-promo-fallback wholesale shows instead when a rep is ordering for a retailer.
// Returns '' when there is nothing to do, so callers keep their plain wholesale markup.
function ttaStaffPriceMarkup(cents, fmt) {
  var pct = parseInt(document.body.getAttribute('data-tta-staff-pct') || '0', 10) || 0;
  if (pct <= 0 || !(cents > 0)) return '';
  var disc = Math.floor(cents * pct / 100);
  return '<span class="td-money-hidable tta-sale-price tta-rep-hide tta-staff-only">' + fmt(cents - disc) + '</span>' +
    '<span class="tta-was-price tta-rep-hide tta-staff-only">' + fmt(cents) + '</span>' +
    '<span class="td-money-hidable tta-promo-fallback">' + fmt(cents) + '</span>';
}

// TTA shelf availability — personalized cards ([data-td-avail]) get a live stock
// chip from /products/{handle}.js: full run / N of M sizes / out of stock (dimmed).
// Small concurrency so a 32-card homepage doesn't burst the CDN.
(function () {
  function start() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-td-avail]')).slice(0, 48);
    if (!cards.length) return;
    var i = 0, inflight = 0, MAX = 4;
    function next() { while (inflight < MAX && i < cards.length) run(cards[i++]); }
    function run(card) {
      inflight++;
      fetch('/products/' + card.getAttribute('data-td-avail') + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d) apply(card, d); })
        .catch(function () {})
        .then(function () { inflight--; next(); });
    }
    // Sep 15: staff pricing on the profile cards. They print a pre-formatted wholesale from the
    // profile metafield — no product object, so tta-sale-rules can't run on them server-side
    // (retailer PROMOS on these cards are likewise not resolvable here — the PDP quotes them).
    // Two passes: (1) every profile card is repriced NOW from the wholesale it already prints —
    // the fetch below is capped at 48 cards and /pages/your-line carries 75, so a fetch-only
    // reprice left the tail at wholesale on the first run; (2) when a card's product JSON does
    // arrive, the live price_min overwrites the profile figure if the nightly build went stale.
    var staffPct = parseInt(document.body.getAttribute('data-tta-staff-pct') || '0', 10) || 0;
    var mf = document.body.getAttribute('data-mf');
    function fmt(cents) {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, mf);
      return '$' + (cents / 100).toFixed(2);
    }
    function repriceCents(card, cents) {
      var box = card.querySelector('.price');
      if (!box || box.getAttribute('data-tta-repriced') === String(cents)) return;
      var html = ttaStaffPriceMarkup(cents, fmt);
      if (!html) return;
      box.innerHTML = html;
      box.setAttribute('data-tta-repriced', String(cents));
    }
    function repriceFromText(card) {
      var box = card.querySelector('.price');
      if (!box || box.hasAttribute('data-tta-repriced')) return;
      var el = box.querySelector('.td-money-hidable');
      var txt = el ? el.textContent.replace(/[^0-9.]/g, '') : '';
      if (!txt) return;
      repriceCents(card, Math.round(parseFloat(txt) * 100));
    }
    function reprice(card, d) {
      var cents = typeof d.price_min === 'number' ? d.price_min : d.price;
      repriceCents(card, cents);
    }
    if (staffPct > 0) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-td-avail]'), repriceFromText);
    }
    function apply(card, d) {
      reprice(card, d);
      var total = d.variants.length;
      var avail = d.variants.filter(function (v) { return v.available; }).length;
      var chip = card.querySelector('[data-td-stock]');
      if (!chip) return;
      var label = chip.querySelector('[data-td-stock-label]');
      var mode = card.getAttribute('data-td-avail-mode') || 'rec';
      // Jeff 08-20: recommendations never talk a buyer OUT of a style — positive
      // signal or silence. Their OWN reorder shelf gets the honest urgency read
      // (a breaking run on their best-seller IS the reorder trigger).
      if (avail === 0) {
        // Jeff 08-25: hide out-of-stock on Your Reorders too. Sinking them to the end
        // still spent grid cells on styles nobody can buy, and the shelf is now capped
        // at two rows — every cell has to earn its place.
        card.style.display = 'none'; return;
      } else if (avail < total) {
        if (mode === 'rec') return;                    // partial run: say nothing, keep selling
        // Audit 08-25: this fired on 7 of 7 cards, so the amber carried NO signal — and the
        // same amber means a neutral fact one shelf down. Urgency now needs a genuinely thin
        // run: under 40% of the size curve left, or 3 sizes or fewer. Anything above that is
        // a normal working run and says nothing.
        var thin = (avail <= 3) || (total > 0 && (avail / total) <= 0.4);
        if (!thin) return;
        chip.hidden = false; chip.classList.add('td-chip--low');
        label.textContent = avail + ' size' + (avail === 1 ? '' : 's') + ' left — reorder soon';
      } else {
        chip.hidden = false; label.textContent = 'Full size run';
      }
    }
    next();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

// TTA sale display: when the PDP carries a promo (rules.json), the discounted figure
// is the visible price — strike the theme's own price and keep it struck through the
// price-area repaints the theme does on variant changes.
(function () {
  function arm() {
    if (!document.querySelector('[data-tta-sale]')) return;
    var cont = document.querySelector('.price-cont');
    if (!cont) return;
    cont.classList.add('tta-orig-struck');
    new MutationObserver(function () {
      if (!cont.classList.contains('tta-orig-struck')) cont.classList.add('tta-orig-struck');
    }).observe(cont, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();

/* ============================================================================
   INSEAM-SAFE QUANTITY STATE  (2026-08-26)

   MEASURED DEFECT: on a multi-inseam style, typing a quantity at one inseam and then
   switching to another silently lost it. Reproduced on 806000-chuck-22 (inseams 30/32/34/36):
   typed 4 units at inseam 30, switched to 32, the input reset to 0 — while the order summary
   still read "4 units selected · $444.80" — pressed Add to Cart, and the cart stayed EMPTY.
   A lying summary plus a silent zero-order, on the one screen where money is written.

   Two causes, both fixed here:
     1. the size table re-renders on inseam change, resetting inputs to server state
     2. the add-to-cart collector only ever read `.data-wrap.inseam` — the SELECTED inseam —
        so even a surviving quantity on another inseam could never be submitted
        (theme.js:6835 strips .inseam from every wrap and re-adds it only to the selection)

   The fix is to stop treating the DOM as the source of truth for what the buyer has keyed.
   One map, variantId -> qty, written on every edit and restored after any re-render. The
   collector and the summary both read the union of DOM and map, so neither can drift from
   what he actually typed.
   ============================================================================ */
window.ttaQty = (function () {
  var qty = {};                       // variantId -> units keyed this session
  function readDom() {
    document.querySelectorAll('.data-wrap[data-variant]').forEach(function (w) {
      var id = w.getAttribute('data-variant');
      var i = w.querySelector('.quantity-input');
      if (!id || !i) return;
      var v = parseInt(i.value) || 0;
      // only trust a visible cell — a hidden one may already have been reset by a re-render
      if (w.offsetParent !== null || v > 0) qty[id] = v;
    });
  }
  function restore() {
    document.querySelectorAll('.data-wrap[data-variant]').forEach(function (w) {
      var id = w.getAttribute('data-variant');
      var i = w.querySelector('.quantity-input');
      if (!id || !i || !(id in qty)) return;
      var want = qty[id];
      var max = parseInt(i.getAttribute('max'));
      if (!isNaN(max) && max >= 0) want = Math.min(want, max);
      if ((parseInt(i.value) || 0) !== want) i.value = String(want);
    });
  }
  function all() { readDom(); return qty; }
  function units() { readDom(); var n = 0; for (var k in qty) n += qty[k] || 0; return n; }
  function clear() { qty = {}; }
  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('quantity-input')) readDom();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.btnqty')) setTimeout(readDom, 60);
  }, true);
  // The table re-renders on inseam change; put the buyer's numbers back.
  //
  // ⚠️ This froze the page solid for ~15 minutes of test time before it was caught.
  // Two compounding mistakes, both worth remembering:
  //   1. querySelector('.v-table-cont, .v-table-main') returns the first match in DOCUMENT
  //      ORDER, not the first selector in the list — so it resolved to the OUTER
  //      .v-table-main, which contains the buy bar.
  //   2. The callback calls ttaRecalcSummary(), which rewrites the order-summary text —
  //      inside that observed subtree. Mutation -> callback -> mutation, forever.
  // The renderer main thread pegged and every page interaction stopped. Guarded three ways
  // now: observe the inner container only, refuse re-entry, and detach while writing.
  if (window.MutationObserver) {
    var host = document.querySelector('.v-table-cont');
    if (host) {
      var busy = false, queued = false;
      var mo = new MutationObserver(function () {
        if (busy) { return; }                     // never let our own writes re-trigger us
        if (queued) { return; }
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false; busy = true;
          try {
            mo.disconnect();                      // belt and braces: no records while writing
            restore();
            if (window.jQuery && typeof window.ttaRecalcSummary === 'function') window.ttaRecalcSummary();
          } finally {
            mo.observe(host, { childList: true, subtree: true });
            busy = false;
          }
        });
      });
      mo.observe(host, { childList: true, subtree: true });
    }
  }
  document.addEventListener('DOMContentLoaded', readDom);
  readDom();
  return { all: all, units: units, restore: restore, clear: clear, readDom: readDom };
})();

/* ============================================================================
   FORGIVING SEARCH  (08-26)
   Jeff: "a lot of times people are not seeing things if they add a hyphen, or
   don't add a hyphen."

   Measured against this store's own search (suggest.json, 08-26):
       "806000"   ->  0 hits        "80-6000"  ->  2 hits     "80 6000"  -> 5 hits
       "chuck-22" ->  0 hits        "chuck 22" -> 10 hits
       "071422"   ->  0 hits        "07-1422"  ->  4 hits
   So the hyphen is a HARD TOKEN BOUNDARY, and a run of digits typed without one
   matches nothing at all. Style numbers here are NN-NNNN, which is exactly the
   thing a buyer reads off a hangtag or a spreadsheet and retypes without the dash.

   Word searches are already fuzzy ("varvato", "varvatoss" both hit), so this only
   touches the two cases that measurably fail. Conservative on purpose: if the term
   has no separator and is not a bare digit run, it is passed through untouched.
   ========================================================================== */
window.ttaSearchVariants = function (raw) {
  var q = String(raw == null ? '' : raw).trim();
  if (!q) return [];
  var out = [], seen = {};
  function push(v) {
    v = v.replace(/\s+/g, ' ').trim();
    if (v && !seen[v.toLowerCase()]) { seen[v.toLowerCase()] = 1; out.push(v); }
  }

  // A style number is an IDENTIFIER, not a phrase — expand it to exact forms only and
  // return early. Measured: splitting "34-3897" into "34 3897" returns 10 products
  // (MARON S 344-72-5848, Mara S 394 …) because "34" matches every size-34 style, and
  // NONE of them is the garment asked for. A confident wrong answer is worse than none.
  var style = q.replace(/\s+/g, '').match(/^(\d{2})-?(\d{4})$/);
  if (style) {
    push(style[1] + '-' + style[2]);                     // 34-3897  (the canonical form)
    push(style[1] + style[2]);                           // 343897
    if (style[1].charAt(0) === '0') {
      push(style[1].charAt(1) + '-' + style[2]);         // 07-1323 -> 7-1323 (title tail form)
    }
    return out;
  }

  push(q);

  // 1. separators -> spaces. Fixes "chuck-22" and turns "80-6000" into the broader "80 6000".
  if (/[-_/.]/.test(q)) push(q.replace(/[-_/.]+/g, ' '));

  // 2. a bare digit run is almost always a style number with the dash left out.
  //    Re-insert it where this catalogue puts it (NN-NNNN) and also offer the spaced form.
  var digits = q.replace(/\s+/g, '');
  if (/^\d{5,8}$/.test(digits)) {
    push(digits.slice(0, 2) + '-' + digits.slice(2));
    push(digits.slice(0, 2) + ' ' + digits.slice(2));
  }

  // 3. token stuck to a number ("chuck22") -> split it
  var m = q.match(/^([a-z]+)(\d+)$/i);
  if (m) push(m[1] + ' ' + m[2]);

  return out;
};

/* Ask the store for each candidate in order and keep the first that actually returns
   something. One extra request only when the first form comes back empty — the common
   case (a term that already works) costs nothing beyond what the theme already did. */
window.ttaSearchResolve = function (raw, cb) {
  var variants = window.ttaSearchVariants(raw);
  if (!variants.length) { cb(raw, null); return; }
  var i = 0;
  function attempt() {
    if (i >= variants.length) { cb(raw, null); return; }
    var v = variants[i++];
    fetch('/search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=10')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var n = ((j.resources || {}).results || {}).products || [];
        if (n.length) { cb(v, n); } else { attempt(); }
      })
      .catch(function () { attempt(); });
  }
  attempt();
};

/* ----------------------------------------------------------------------------
   STYLE-NUMBER FALLBACK
   Measured 08-26: this storefront's search indexes the TITLE and the DESCRIPTION but
   NOT tags and NOT the SKU ("802000COOPFAN" -> 0 hits, and the pure tags "booking" and
   "over-51" -> 0 hits). 92.2% of Brax titles carry the style number, so those resolve
   through the query variants above. The remaining ~166 — mostly Brax Ladies knitwear —
   have no code anywhere indexed, so no amount of query rewriting will find them.
   For those, resolve the number locally against a generated index and go straight to
   the style. Lazy-loaded: the file is only fetched when a style-shaped query has already
   come back empty, which for most searches never happens.
   ---------------------------------------------------------------------------- */
window.ttaStyleLookup = (function () {
  var cache = null, pending = null;
  function load() {
    if (cache) return Promise.resolve(cache);
    if (pending) return pending;
    var url = (window.ttaStyleIndexUrl || '');
    if (!url) return Promise.resolve(null);
    pending = fetch(url).then(function (r) { return r.json(); })
      .then(function (j) { cache = j; return j; })
      .catch(function () { return null; });
    return pending;
  }
  return function (code) {
    return load().then(function (idx) {
      if (!idx) return null;
      var handles = idx[code];
      return handles && handles.length ? { handles: handles, code: code } : null;
    });
  };
})();

(function () {
  // Rewrite the submitted term only when the typed one finds nothing. The buyer keeps
  // seeing what they typed; only the query that goes to the server is widened.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/search"]')) return;
    if (form.hasAttribute('data-tta-widened')) { form.removeAttribute('data-tta-widened'); return; }
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    var variants = window.ttaSearchVariants(input.value);
    if (variants.length < 2) return;                 // nothing to widen — let it through

    e.preventDefault();
    var typed = input.value.trim();

    // 09-25 (Jeff: "search needs to give options and be lenient" — a rep typed 855828 and landed on a 404):
    // this used to jump straight to handles[0] of the local style index for anything style-shaped. That
    // index carries every colour ever created, published or not, so the FIRST one could be a dead 2024
    // colour, and even when it worked the buyer never saw the other colours. Now a style number goes to
    // the results page like any other term (the store finds "875828", "87-5828" and "8558"); the index is
    // only consulted BY THE RESULTS PAGE when text search comes back empty — see ttaStyleFallback.
    window.ttaSearchResolve(typed, function (winner) { submitWith(winner); });
    function submitWith(winner) {
      if (winner && winner !== input.value) { input.value = winner; }
      form.setAttribute('data-tta-widened', '1');
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
    }
  }, true);
})();


/* ----------------------------------------------------------------------------
   STYLE-NUMBER FALLBACK ON THE RESULTS PAGE (09-25)
   When the search page has NO results and the term is style-shaped (NN-NNNN / NNNNNN, or a
   4+ digit prefix), ask the local Brax style index for handles, render each one that is
   actually live as a normal product card (/products/<handle>?view=card — the same
   product-block snippet the grids use, so pricing, badges and rep mode are right), and
   replace the empty state with "Styles matching …". A handle that 404s (unpublished) or has
   no sellable size is skipped — never a dead link, never a jump.
   ---------------------------------------------------------------------------- */
(function () {
  var box = document.getElementById('td-style-fallback');
  if (!box || !window.ttaStyleIndexUrl) return;
  var typed = (box.getAttribute('data-terms') || '').trim();
  var digits = typed.replace(/[\s-]+/g, '');
  if (!/^\d{4,6}$/.test(digits)) return;
  fetch(window.ttaStyleIndexUrl).then(function (r) { return r.json(); }).then(function (idx) {
    var want = digits.length >= 6 ? [digits.slice(0, 2) + '-' + digits.slice(2, 6)] : Object.keys(idx).filter(function (k) { return k.replace('-', '').indexOf(digits) === 0; }).sort();
    var handles = [];
    want.forEach(function (k) { (idx[k] || []).forEach(function (h) { if (handles.indexOf(h) < 0) handles.push(h); }); });
    if (!handles.length) return;
    handles = handles.slice(0, 24);
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      var live = cards.filter(function (c) { return c && c.indexOf('product-block') > -1 && c.indexOf('soldout') < 0; });
      if (!live.length) return;
      var empty = document.querySelector('.td-empty-state');
      var h = document.createElement('div');
      h.className = 'td-style-fallback';
      h.innerHTML = '<h5 class="td-style-fallback__title">' + live.length + ' style' + (live.length === 1 ? '' : 's') + ' matching \u201c' + typed.replace(/[<>&]/g, '') + '\u201d</h5>' +
        '<div class="product-list product-list--collection product-list--per-row-4 product-list--per-row-mob-2">' + live.join('') + '</div>';
      if (empty) empty.replaceWith(h); else box.appendChild(h);
    });
  }).catch(function () {});
})();

/* ============================================================================
   STICKY MOBILE CART BAR  (08-26)
   Shows only while the real Checkout is off-screen, so there is never a moment
   with two identical buttons visible. Mirrors the real control's disabled state
   rather than keeping its own idea of whether checkout is allowed — the booking
   lane guard disables #update-cart, and a bar that stayed live would let a buyer
   press a button that cannot work.
   ========================================================================== */
(function () {
  var bar = document.getElementById('td-cartbar');
  if (!bar) return;
  var realGo = document.getElementById('update-cart');
  var repBlock = document.getElementById('td-rep-actions');
  var barGo = document.getElementById('td-cartbar-go');
  var barRep = document.getElementById('td-cartbar-rep');
  var mq = window.matchMedia('(max-width: 767px)');

  function repActive() {
    return !!(repBlock && !repBlock.hasAttribute('hidden') && repBlock.offsetParent !== null);
  }
  function sync() {
    if (!mq.matches) { bar.setAttribute('hidden', ''); document.body.classList.remove('td-cartbar-on'); return; }
    var rep = repActive();
    // In rep mode the primary action places an order on someone else's account.
    // Never proxy that from a sticky bar — offer to take them to it instead.
    if (rep) { barGo.setAttribute('hidden', ''); barRep.removeAttribute('hidden'); }
    else { barRep.setAttribute('hidden', ''); barGo.removeAttribute('hidden'); }
    if (realGo && !rep) {
      if (realGo.disabled) { barGo.setAttribute('disabled', 'disabled'); barGo.title = realGo.title || ''; }
      else { barGo.removeAttribute('disabled'); barGo.title = ''; }
    }
  }
  function show(on) {
    if (!mq.matches || !on) { bar.setAttribute('hidden', ''); document.body.classList.remove('td-cartbar-on'); return; }
    bar.removeAttribute('hidden'); document.body.classList.add('td-cartbar-on');
    sync();
  }

  barRep.addEventListener('click', function () {
    var target = document.getElementById('td-rep-place') || repBlock;
    if (target && target.scrollIntoView) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });

  var anchor = repActive() ? repBlock : (realGo || repBlock);
  if (anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { show(!e.isIntersecting); });
      // Measure the bar rather than hard-coding a guess: the safe-area inset makes it
      // taller on a notched phone, and a margin that is too small hands over while the
      // real button is still behind the bar.
    }, { rootMargin: '0px 0px -' + Math.max(80, Math.round(bar.getBoundingClientRect().height) + 12) + 'px 0px' }).observe(anchor);
  } else {
    show(true);
  }
  // the lane guard and rep-mode toggle both flip attributes after load
  if (window.MutationObserver) {
    var watch = [realGo, repBlock].filter(Boolean);
    watch.forEach(function (el) {
      new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['disabled', 'hidden', 'style', 'class'] });
    });
  }
  mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
  sync();
})();


/* ============================================================================
   SCAN TO REORDER  (V2.5, 08-26)

   Storefront search indexes TITLE and DESCRIPTION only — a full UPC returns 0 hits,
   exactly like a SKU (both measured 08-26). So a scan cannot go through search; it
   resolves against a local index of 36,742 barcodes over 4,222 products, adaptively
   sharded so one scan downloads ~45KB for its prefix and caches it.

   Retail scanners are keyboard emulators: they type the digits very fast and send Enter.
   So this needs no camera, no permission and no library — just a focused field that
   recognises the burst. A human can also type a UPC, and a phone camera app that types
   into the field works unchanged.
   ========================================================================== */
(function () {
  var root = document.getElementById('td-scan');
  if (!root) return;
  var openBtn = document.querySelector('[data-td-scan-open]');
  var input = root.querySelector('[data-td-scan-input]');
  var status = root.querySelector('[data-td-scan-status]');
  var list = root.querySelector('[data-td-scan-list]');
  var goBtn = root.querySelector('[data-td-scan-go]');
  var clearBtn = root.querySelector('[data-td-scan-clear]');
  var found = [];                       // [{barcode, handle, title, img, url}]
  var shardCache = {};
  var manifest = null;
  var lastFocus = null;

  function say(msg, kind) {
    status.textContent = msg || '';
    status.className = 'td-scan__status' + (kind ? ' is-' + kind : '');
  }

  function manifestUrl() { return window.ttaUpcManifestUrl || ''; }
  function shardUrl(prefix) {
    // Asset URLs are CDN-hashed, so we cannot concatenate one. Derive it from the
    // manifest's URL by swapping the filename — same folder, same query string.
    var m = manifestUrl();
    if (!m) return '';
    return m.replace('tta-upc-manifest.json', 'tta-upc-' + prefix + '.json');
  }

  function loadManifest() {
    if (manifest) return Promise.resolve(manifest);
    var u = manifestUrl();
    if (!u) return Promise.resolve(null);
    return fetch(u).then(function (r) { return r.json(); })
      .then(function (j) { manifest = j; return j; })
      .catch(function () { return null; });
  }

  // Longest matching prefix wins — the index is adaptively sharded, so prefixes vary
  // in length (2 to 8 characters) depending on how dense that range is.
  function prefixFor(code, mf) {
    if (!mf || !mf.prefixes) return null;
    var best = null;
    for (var i = 0; i < mf.prefixes.length; i++) {
      var p = mf.prefixes[i];
      if (code.indexOf(p) === 0 && (!best || p.length > best.length)) best = p;
    }
    return best;
  }

  function loadShard(prefix) {
    if (shardCache[prefix]) return Promise.resolve(shardCache[prefix]);
    var u = shardUrl(prefix);
    if (!u) return Promise.resolve(null);
    return fetch(u).then(function (r) { return r.json(); })
      .then(function (j) { shardCache[prefix] = j; return j; })
      .catch(function () { return null; });
  }

  // The catalogue holds BOTH forms: 20,015 twelve-digit UPC-A and 16,685 thirteen-digit
  // EAN-13 (measured in the shipped index). UPC-A *is* EAN-13 with a leading zero, and
  // different scanners hand back different forms of the same tag — so an exact-match
  // lookup silently misses the majority of products. Try every equivalent form.
  function upcForms(code) {
    var out = [code];
    if (code.length === 13 && code.charAt(0) === '0') out.push(code.slice(1));   // EAN-13 -> UPC-A
    if (code.length === 12) out.push('0' + code);                                 // UPC-A -> EAN-13
    if (code.length === 11) out.push('0' + code, '00' + code);                    // short UPC-E-ish
    return out;
  }
  function resolveOne(code) {
    return loadManifest().then(function (mf) {
      var pfx = prefixFor(code, mf);
      if (!pfx) return null;
      return loadShard(pfx).then(function (shard) {
        if (!shard) return null;
        var idx = shard.b[code.slice(pfx.length)];
        if (idx === undefined) return null;
        return shard.h[idx];
      });
    });
  }
  function resolve(code) {
    var forms = upcForms(code), i = 0;
    function next() {
      if (i >= forms.length) return Promise.resolve(null);
      return resolveOne(forms[i++]).then(function (h) { return h || next(); });
    }
    return next();
  }

  function paint() {
    list.innerHTML = '';
    found.forEach(function (f) {
      var li = document.createElement('li');
      li.className = 'td-scan__item';
      li.innerHTML = (f.img ? '<img src="' + f.img + '" alt="">' : '<span class="td-scan__ph"></span>') +
        '<span class="td-scan__t">' + (f.title || f.handle) + '</span>' +
        '<span class="td-scan__c">' + f.barcode + '</span>';
      list.appendChild(li);
    });
    if (found.length === 0) { goBtn.hidden = true; clearBtn.hidden = true; return; }
    clearBtn.hidden = false;
    goBtn.hidden = false;
    // 28 characters of an uppercase, letter-spaced product name is far wider than a phone.
    // The CSS truncates as a backstop, but a button that just says "Open" reads better than
    // a clipped half-sentence.
    goBtn.textContent = found.length === 1
      ? (window.matchMedia('(max-width: 767px)').matches
          ? 'Open this style →'
          : 'Open ' + (found[0].title || 'style').slice(0, 28))
      : 'Size ' + found.length + ' styles →';
  }

  var claimed = {};        // barcodes whose lookup is already under way
  function handleCode(raw) {
    var code = String(raw || '').replace(/\D/g, '');
    if (code.length < 6) { say('That does not look like a UPC.', 'warn'); return; }
    // Reserve the code BEFORE the async lookup. Checking only the rendered list let several
    // in-flight lookups for the same tag all pass, then all push.
    if (claimed[code] || found.some(function (f) { return f.barcode === code; })) {
      // Holding a tag in front of a live camera re-reads it constantly. That is normal,
      // so it gets a neutral note, not an amber warning that implies a mistake.
      say('Already on the list — ' + code, stream ? '' : 'warn'); return;
    }
    claimed[code] = 1;
    say('Looking up ' + code + '…');
    resolve(code).then(function (handle) {
      if (!handle) {
        // Say WHICH code failed. "Not found" with no code is useless on a fast scan run.
        delete claimed[code];                 // let them try that tag again
        say('No match for ' + code + ' (tried ' + upcForms(code).join(' / ') + '). Not on the platform yet.', 'bad');
        return;
      }
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          var item = {
            barcode: code, handle: handle,
            url: '/products/' + handle,
            title: prod ? prod.title.replace(/^\([^)]*\)\s*/, '') : handle,
            img: prod && prod.featured_image ? prod.featured_image : ''
          };
          found.push(item);
          paint();
          say(found.length === 1
            ? 'Found ' + item.title + '. Scan another, or open it.'
            : found.length + ' styles ready for your sizing run.', 'good');
        });
    }).catch(function () { delete claimed[code]; say('Lookup failed — check the connection.', 'bad'); });
  }

  // A scanner fires Enter. A typist may not, so also settle on a pause once the string
  // is long enough to be a barcode.
  var settle = null;
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(settle);
      handleCode(input.value);
      input.value = '';
    }
  });
  input.addEventListener('input', function () {
    clearTimeout(settle);
    var v = input.value.replace(/\D/g, '');
    if (v.length >= 8) {
      settle = setTimeout(function () { handleCode(input.value); input.value = ''; }, 260);
    }
  });

  /* ---------------------------------------------------------------------------
     CAMERA (Jeff 08-26: "scan on mobile should use the camera")
     BarcodeDetector is native in Chromium and covers ean_13 / upc_e / code_128 — the
     retail formats — so no library and no bundle. It is NOT in every browser, so the
     button is only shown where it genuinely works; elsewhere the typed / hardware-scanner
     path stays exactly as it was rather than offering a control that fails.
     The stream is released on every exit path: a camera left running on a rep's phone is
     a battery and a privacy problem.
     --------------------------------------------------------------------------- */
  var camWrap = root.querySelector('[data-td-cam-wrap]');
  var camVideo = root.querySelector('[data-td-cam-video]');
  var camStart = root.querySelector('[data-td-cam-start]');
  var camStop = root.querySelector('[data-td-cam-stop]');
  var orLine = root.querySelector('[data-td-scan-or]');
  var stream = null, detector = null, rafId = null, lastHit = 0;

  // iOS Safari ships no Shape Detection API, so BarcodeDetector is absent there and the
  // camera button used to hide itself — which is exactly what Jeff hit on his iPhone.
  // tta-ean.js is a small purpose-built EAN-13/UPC-A decoder for that case, so the camera
  // works on iOS without pulling a 200KB third-party library into the store.
  var hasNative = ('BarcodeDetector' in window);
  var hasFallback = (typeof window.ttaDecodeEAN === 'function');
  var camSupported = (hasNative || hasFallback) &&
    !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) && window.isSecureContext;
  var camCanvas = null, camCtx = null;
  if (camSupported && camStart) {
    camStart.removeAttribute('hidden');
    if (orLine) orLine.removeAttribute('hidden');
    // Copy must describe the input this device actually has. "Pull the trigger" is
    // nonsense on a phone with no hardware scanner.
    var hint = root.querySelector('.td-scan__hint');
    if (hint && window.matchMedia('(max-width: 767px)').matches) {
      hint.textContent = 'Point your camera at the barcode. Scan one item to open it, ' +
        'or keep scanning to load a whole run into your sizing queue.';
    }
  }

  function stopCam() {
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    if (stream) { stream.getTracks().forEach(function (tr) { try { tr.stop(); } catch (e) {} }); stream = null; }
    if (camVideo) camVideo.srcObject = null;
    if (camWrap) camWrap.setAttribute('hidden', '');
    if (camStart) camStart.removeAttribute('hidden');
  }

  var detecting = false;
  function tick() {
    if (!stream) return;
    rafId = requestAnimationFrame(tick);
    if (!camVideo.videoWidth) return;
    if (Date.now() - lastHit < 1200) return;          // don't re-fire on the same tag

    // ---- fallback path (iOS): pull a frame and decode it ourselves ----
    if (!detector) {
      if (detecting) return;
      detecting = true;
      try {
        if (!camCanvas) { camCanvas = document.createElement('canvas'); camCtx = camCanvas.getContext('2d', { willReadFrequently: true }); }
        // downscale a little: plenty of resolution for a 95-module barcode, much less work
        var cw = Math.min(960, camVideo.videoWidth);
        var ch = Math.round(camVideo.videoHeight * (cw / camVideo.videoWidth));
        if (camCanvas.width !== cw) { camCanvas.width = cw; camCanvas.height = ch; }
        camCtx.drawImage(camVideo, 0, 0, cw, ch);
        var code = window.ttaDecodeEAN(camCanvas);
        if (code) {
          lastHit = Date.now();
          if (navigator.vibrate) { try { navigator.vibrate(35); } catch (e) {} }
          handleCode(code);
        }
      } catch (e) { /* a bad frame is not worth surfacing */ }
      detecting = false;
      return;
    }

    // detect() is ASYNC. Without an in-flight guard, rAF launches dozens of detections
    // before the first one returns — every single one passes the throttle (lastHit is
    // still stale) and the same tag lands in the list 20 times. Measured, not theorised.
    if (detecting) return;
    detecting = true;
    detector.detect(camVideo).then(function (codes) {
      if (!codes || !codes.length) return;
      var raw = String(codes[0].rawValue || '').replace(/\D/g, '');
      if (raw.length < 6) return;
      lastHit = Date.now();
      if (navigator.vibrate) { try { navigator.vibrate(35); } catch (e) {} }
      root.querySelector('.td-scan__panel').classList.add('td-scan__flash');
      setTimeout(function () { root.querySelector('.td-scan__panel').classList.remove('td-scan__flash'); }, 500);
      handleCode(raw);
    }).catch(function () { /* a dropped frame is not an error worth surfacing */ })
      .then(function () { detecting = false; });
  }

  async function startCam() {
    if (!camSupported) return;
    try {
      say('Starting camera…');
      if (hasNative) {
        detector = detector || new window.BarcodeDetector({
          formats: ['ean_13', 'ean_8', 'upc_e', 'code_128', 'code_39', 'itf']
        });
      }   // else: detector stays null and tick() uses the tta-ean fallback
      stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 } }, audio: false
      });
      camVideo.srcObject = stream;
      await camVideo.play().catch(function () {});
      camWrap.removeAttribute('hidden');
      camStart.setAttribute('hidden', '');
      say('Point the camera at a tag.');
      lastHit = 0;
      tick();
    } catch (err) {
      stopCam();
      // Name the actual reason — "camera failed" tells a rep nothing they can act on.
      var msg = (err && err.name === 'NotAllowedError')
        ? 'Camera permission was refused. Allow it in your browser settings, or type the UPC below.'
        : (err && err.name === 'NotFoundError')
          ? 'No camera on this device — type or scan the UPC below.'
          : 'Could not start the camera. Type or scan the UPC below.';
      say(msg, 'bad');
    }
  }

  if (camStart) camStart.addEventListener('click', function (e) { e.preventDefault(); startCam(); });
  if (camStop) camStop.addEventListener('click', function (e) { e.preventDefault(); stopCam(); say('Camera off.'); });

  function open() {
    if (root.getAttribute('data-open') === '1') return;   // inline opener may have fired first
    root.setAttribute('data-open', '1');
    lastFocus = document.activeElement;
    root.removeAttribute('hidden');
    document.body.classList.add('td-scan-on');
    say('');
    paint();
    loadManifest();
    // On a phone the camera is the point, so do NOT steal focus into the text field and
    // pop the keyboard over the sheet. On desktop the field is the scanner's target.
    if (!camSupported || !window.matchMedia('(max-width: 767px)').matches) {
      setTimeout(function () { input.focus(); input.select(); }, 30);
    }
  }
  function close() {
    stopCam();
    root.removeAttribute('data-open');
    root.setAttribute('hidden', '');
    document.body.classList.remove('td-scan-on');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.addEventListener('pagehide', stopCam);
  document.addEventListener('visibilitychange', function () { if (document.hidden) stopCam(); });

  // The inline opener (snippets/tta-scan.liquid) is what actually reveals the sheet, so a
  // tap always does something even if this bundle never ran. Here we only do the parts that
  // need the module: focus policy, manifest preload, list paint.
  document.addEventListener('tta:scan-open', function () { open(); });
  if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-td-scan-close]') || e.target === root) { close(); return; }
    if (e.target.closest('[data-td-scan-clear]')) { found = []; claimed = {}; paint(); say('List cleared.'); if (!stream) input.focus(); return; }
    if (e.target.closest('[data-td-scan-go]')) {
      if (found.length === 1) { location.href = found[0].url; return; }
      // Multiple: load them into the SAME sizing queue the quick-add buttons feed, then
      // start the run — no second, parallel queue concept for the buyer to learn.
      if (window.ttaBatch) {
        found.forEach(function (f) {
          window.ttaBatch.add({ url: f.url, handle: f.handle, title: f.title, img: f.img });
        });
        window.ttaBatch.start();
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
  });

  /* SCANNER WEDGE.
     On a phone the sheet deliberately does NOT focus the text field — that would pop the
     on-screen keyboard over the viewfinder. But a Bluetooth scanner paired to a phone types
     into whatever is focused, so without this its scan would go nowhere.
     A hardware scanner is distinguishable from a human by SPEED: it emits a burst of digits
     in a few milliseconds and ends with Enter. Capture that burst at document level while
     the sheet is open, whatever has focus. A person typing (>60ms between keys) is ignored
     here and handled by the field itself. */
  var wedge = '', wedgeAt = 0;
  document.addEventListener('keydown', function (e) {
    if (root.hasAttribute('hidden')) return;
    if (e.target === input) return;                 // the field handles its own input
    var now = Date.now();
    if (e.key === 'Enter') {
      if (wedge.length >= 6 && now - wedgeAt < 3000) { e.preventDefault(); handleCode(wedge); }
      wedge = ''; return;
    }
    if (!/^[0-9]$/.test(e.key)) { wedge = ''; return; }
    // Originally gated on a 60ms inter-key gap to "detect a scanner". That was fragile —
    // a busy page stretches even a scanner's burst past the threshold, and the wedge then
    // silently collected nothing. It also bought nothing: this sheet exists ONLY to receive
    // a scan, so digits typed here are a scan whatever the speed. Just reset after a pause.
    if (now - wedgeAt > 2000) wedge = '';
    wedge += e.key;
    wedgeAt = now;
  }, true);
  // keep focus in the field so a scanner never types into the page behind
  root.addEventListener('focusout', function () {
    if (root.hasAttribute('hidden')) return;
    if (stream) return;              // camera is the input right now; don't pop the keyboard
    setTimeout(function () {
      if (!root.hasAttribute('hidden') && !root.contains(document.activeElement)) input.focus();
    }, 10);
  });
})();


/* ============================================================================
   ON-ORDER "NOTIFY ME"  (V2.5, 08-26)
   Captured through Shopify's native contact form — it emails the store, so there is no
   new endpoint to keep alive and nothing to go stale. The card is a link to the PDP, so
   the notify control must stop the navigation it sits inside.
   ========================================================================== */
(function () {
  var dlg = document.getElementById('td-notify');
  if (!dlg) return;
  var styleLine = dlg.querySelector('[data-td-notify-style]');
  var field = dlg.querySelector('[data-td-notify-field]');
  var last = null;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-td-notify]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();     // the whole card is an <a> to the PDP
      var title = btn.getAttribute('data-title') || '';
      var style = btn.getAttribute('data-style') || '';
      styleLine.textContent = title + (style ? '  ·  Style ' + style : '');
      if (field) field.value = (style ? style + ' — ' : '') + title + ' (' + (btn.getAttribute('data-handle') || '') + ')';
      last = document.activeElement;
      dlg.removeAttribute('hidden');
      document.body.classList.add('td-notify-on');
      var email = dlg.querySelector('input[type=email]');
      setTimeout(function () { if (email) email.focus(); }, 30);
      return;
    }
    if (e.target.closest('[data-td-notify-close]') || e.target === dlg) {
      dlg.setAttribute('hidden', '');
      document.body.classList.remove('td-notify-on');
      if (last && last.focus) last.focus();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !dlg.hasAttribute('hidden')) {
      dlg.setAttribute('hidden', ''); document.body.classList.remove('td-notify-on');
    }
  });
  // Shopify returns ?contact_posted=true — reopen so the confirmation is actually seen
  if (/contact_posted=true/.test(location.search)) {
    dlg.removeAttribute('hidden');
    document.body.classList.add('td-notify-on');
  }
})();


/* ============================================================================
   QUANTITY FLOOR  (08-26, found by the red-team QA pass)
   theme.js clamps the CEILING (v > max -> max) but nothing clamps the floor, and
   min="0" is only checked on form submit. Typing "-5" into a size cell left -5 in
   the field, where the collector would happily read it. Negative units on a
   wholesale order is a correctness bug, not a cosmetic one.
   Also normalises decimals and stray text to a whole number of units.
   ========================================================================== */
(function () {
  function clampCell(input) {
    if (!input || !input.classList || !input.classList.contains('quantity-input')) return;
    var raw = String(input.value || '').trim();
    if (raw === '') return;                       // let the buyer clear a field
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 0) n = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && n > max) n = max;
    if (String(n) !== raw) input.value = String(n);
  }
  ['input', 'change', 'blur'].forEach(function (evt) {
    document.addEventListener(evt, function (e) { clampCell(e.target); }, true);
  });
  // belt and braces: never let a negative reach the cart collector
  if (window.ttaQty && typeof window.ttaQty.readDom === 'function') {
    var origRead = window.ttaQty.readDom;
    window.ttaQty.readDom = function () {
      document.querySelectorAll('.data-wrap .quantity-input').forEach(clampCell);
      return origRead.apply(this, arguments);
    };
  }
})();

// ---------------------------------------------------------------------------
// HIDE AN INSEAM THAT HAS NOTHING TO SELL (Brax sales team via Jeff, 2026-09-03)
//
// Brax is the only vendor with an In-Seam option (393 products). A style routinely has a
// whole length dead — 806000-chuck-22 offers L36 with 11 of 11 sizes sold out. Presenting
// it is a wasted tap that ends in a wall of empty boxes.
//
// Driven off the RENDERED GRID rather than variant JSON: variant-table.liquid already
// decides orderability there (including inventory_policy 'continue' and untracked items),
// so reading the cells keeps ONE source of truth. A length is hidden only when EVERY cell
// under it is sold out.
//
// Never hides the last remaining length, and if the buyer is standing on a dead length it
// moves them to a live one FIRST — silently removing the selected option would leave the
// grid rendering nothing.
// ---------------------------------------------------------------------------
(function () {
  function inseamSelect() {
    var sels = document.querySelectorAll('[data-single-option-selector]');
    for (var i = 0; i < sels.length; i++) {
      var wrap = sels[i].closest ? sels[i].closest('.selector-wrapper') : null;
      var label = wrap ? ((wrap.querySelector('label') || {}).textContent || '') : '';
      if (/in-?\s?seam/i.test(label)) return sels[i];
    }
    return null;
  }

  function prune() {
    var sel = inseamSelect();
    if (!sel) return;                      // not an inseam style — nothing to do
    var cells = document.querySelectorAll('.data-wrap[data-variant][data-inseam]');
    if (!cells.length) return;

    var live = {}, seen = {};
    Array.prototype.forEach.call(cells, function (c) {
      var v = (c.getAttribute('data-inseam') || '').trim();
      if (!v) return;                      // styles with no inseam emit data-inseam=""
      seen[v] = true;
      if (!c.classList.contains('sold-out')) live[v] = true;
    });

    var values = Object.keys(seen);
    var liveValues = values.filter(function (v) { return live[v]; });
    // nothing sellable anywhere, or nothing dead: leave the picker exactly as it is
    if (!liveValues.length || liveValues.length === values.length) return;

    var current = (sel.value || '').trim();
    if (current && !live[current]) {
      var box = document.querySelector('.clickyboxes .opt--' + liveValues[0]);
      if (box && box.click) { box.click(); }
      else { sel.value = liveValues[0]; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    values.forEach(function (v) {
      if (live[v]) return;
      var opt = sel.querySelector('option[value="' + v + '"]');
      if (opt) { opt.hidden = true; opt.disabled = true; }
      var boxes = document.querySelectorAll(
        '.clickyboxes .opt--' + v + ', .clickyboxes [data-value="' + v + '"]');
      Array.prototype.forEach.call(boxes, function (b) { b.style.display = 'none'; });
    });
  }

  function boot() {
    prune();
    // theme.js re-renders the option boxes when a colourway changes; re-run behind a rAF
    // so we never fight it inside the same frame
    var host = document.querySelector('.v-table-cont');
    if (host && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; prune(); });
      }).observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
